




// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";
// import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
// import api from "../api";
// import toast from "react-hot-toast";

// /* ── Inject mobile meta + global CSS once ── */
// if (!document.getElementById("mlm-mobile-css")) {
//   const meta = document.createElement("meta");
//   meta.name = "viewport";
//   meta.content = "width=device-width, initial-scale=1, maximum-scale=1";
//   document.head.appendChild(meta);
//   const style = document.createElement("style");
//   style.id = "mlm-mobile-css";
//   style.textContent = `
//     * { box-sizing: border-box; }
//     body { margin: 0; overflow-x: hidden; }
//     input, select, textarea, button { font-size: 16px !important; }
//     @media (max-width: 767px) {
//       .mlm-hide-mobile { display: none !important; }
//       .mlm-table-wrap { overflow-x: auto; -webkit-overflow-scrolling: touch; }
//       .mlm-table-wrap table { min-width: 520px; }
//       .mlm-flex-col { flex-direction: column !important; }
//       .mlm-full { width: 100% !important; max-width: 100% !important; }
//     }
//   `;
//   document.head.appendChild(style);
// }

// const LEVEL_RATE = { 1: 300, 2: 150, 3: 120, 4: 90, 5: 60, 6: 30 };
// const PIE_COLORS = ["#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#06b6d4"];
// const COMPANY = "Meruram";
// const COMPANY_URL = "https://meruram.in";

// const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
// const fmt = (d) => d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—";
// const fmtTime = (d) => d ? new Date(d).toLocaleString("en-IN") : "—";
// const whatsapp = (mobile, msg) => {
//   if (!mobile) { toast.error("No mobile number!"); return; }
//   window.open(`https://wa.me/91${mobile.replace(/\D/g, "")}?text=${encodeURIComponent(msg)}`, "_blank");
// };

// const NAV = [
//   { label: "📊 Dashboard", key: "dashboard" },
//   { label: "👤 Profile", key: "profile", children: ["My Profile", "Welcome Letter", "Change Password"] },
//   { label: "👥 My Team", key: "myteam", children: ["Level Wise Report", "My Direct Tree", "Indirect Tree", "Date Wise Business"] },
//   { label: "💹 My Incentive", key: "incentive", children: ["Direct Income", "Level Income", "Total Payout by Level", "Salary"] },
//   { label: "💰 Wallet", key: "wallet", children: ["Wallet Report", "Withdrawal", "Withdrawal Detail"] },
//   { label: "🎫 Support", key: "support", children: ["Raise Ticket", "Ticket Status"] },
// ];

// /* ── Mobile detection hook ── */
// function useIsMobile() {
//   const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
//   useEffect(() => {
//     const handler = () => setIsMobile(window.innerWidth < 768);
//     window.addEventListener("resize", handler);
//     return () => window.removeEventListener("resize", handler);
//   }, []);
//   return isMobile;
// }

// export default function AdminDashboard() {
//   const { logout } = useAuth();
//   const navigate = useNavigate();
//   const isMobile = useIsMobile();
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [token, setToken] = useState(() => localStorage.getItem("member_token") || "");
//   const [tokenInput, setTokenInput] = useState("");
//   const [data, setData] = useState(null);
//   const [tab, setTab] = useState("dashboard");
//   const [subTab, setSubTab] = useState("");
//   const [openNav, setOpenNav] = useState({});
//   const [ticketForm, setTicketForm] = useState({ nature: "Support", description: "" });
//   const [withdrawForm, setWithdrawForm] = useState({ amount: "", method: "upi" });
//   const [bankForm, setBankForm] = useState({ bank_name: "", account_number: "", ifsc: "", upi_id: "" });
//   // ★ FIX 3: passwordForm REMOVED from main state — now lives inside ChangePasswordPanel

//   useEffect(() => { if (token) fetchData(); }, [token]);

//   const fetchData = async () => {
//     try {
//       const res = await api.get(`/mlm/my-stats/${token}`);
//       setData(res.data);
//     } catch { toast.error("Could not load data. Check your token."); }
//   };

//   const goTo = (t, s = "") => { setTab(t); setSubTab(s); setSidebarOpen(false); };

//   const submitWithdraw = async () => {
//     if (!withdrawForm.amount) { toast.error("Enter amount"); return; }
//     try {
//       await api.post(`/wallet/withdraw/${token}`, withdrawForm);
//       toast.success("Withdrawal request submitted!");
//       fetchData();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const saveBank = async () => {
//     try { await api.put(`/wallet/bank/${token}`, bankForm); toast.success("Bank details saved!"); }
//     catch { toast.error("Save failed"); }
//   };

//   /* ── Login screen ── */
//   if (!token) {
//     return (
//       <div style={S.loginWrap}>
//         <div style={S.loginBox}>
//           <div style={{ textAlign: "center", marginBottom: 28 }}>
//             <div style={S.loginLogo}>मे</div>
//             <div style={{ fontWeight: 900, fontSize: 20, color: "#1e3a8a", marginTop: 10, letterSpacing: 1 }}>MERURAM</div>
//             <div style={{ fontSize: 11, color: "#94a3b8", letterSpacing: 3, marginTop: 2 }}>MEMBER</div>
//           </div>
//           <label style={S.label}>Your Member Token / Coupon No.</label>
//           <input style={S.input} placeholder="e.g. MLAB12345"
//             value={tokenInput} onChange={e => setTokenInput(e.target.value)}
//             onKeyDown={e => e.key === "Enter" && (() => { localStorage.setItem("member_token", tokenInput.trim()); setToken(tokenInput.trim()); })()}
//           />
//           <button style={{ ...S.btnPrimary, width: "100%", marginTop: 14, padding: 12 }}
//             onClick={() => { localStorage.setItem("member_token", tokenInput.trim()); setToken(tokenInput.trim()); }}>
//             Login →
//           </button>
//           <p style={{ textAlign: "center", fontSize: 12, color: "#94a3b8", marginTop: 16 }}>
//             Not a member? <a href="/register" style={{ color: "#ea580c" }}>Register here</a>
//           </p>
//         </div>
//       </div>
//     );
//   }

//   if (!data) return <div style={{ padding: 60, textAlign: "center", color: "#94a3b8", fontSize: 16 }}>Loading your dashboard...</div>;

//   const m = data.member;
//   const stats = data.stats;
//   const levelIncome = data.level_income || [];
//   const levelPayout = data.level_payout || [];
//   const directMembers = data.direct_members || [];
//   const recentTxn = data.recent_transactions || [];
//   const totalPayoutByLevel = data.total_payout_by_level || [];
//   const allTeam = data.all_team || [];
//   const totalIncome = levelIncome.reduce((s, l) => s + Number(l.total || 0), 0);

//   const chartData = [1, 2, 3, 4, 5, 6].map(l => {
//     const found = levelIncome.find(li => li.level === l);
//     return { name: `L${l}`, earned: Number(found?.total || 0), members: found?.count || 0 };
//   });

//   // ★ FIX 2: buildTree — allTeam already has lvl 1–6 from backend WITH RECURSIVE.
//   // Level-1 entries in allTeam ARE the direct members. Wire every member under their
//   // parent using referred_by. No need to loop directMembers separately.
//   const buildTree = () => {
//     const map = {};
//     map[m.token_number] = { ...m, children: [] };
//     // index every team member
//     allTeam.forEach(member => {
//       map[member.token_number] = { ...member, children: [] };
//     });
//     // wire each member under their parent
//     allTeam.forEach(member => {
//       const parent = map[member.referred_by];
//       if (parent) {
//         if (!parent.children.find(c => c.token_number === member.token_number)) {
//           parent.children.push(map[member.token_number]);
//         }
//       }
//     });
//     return map[m.token_number];
//   };

//   return (
//     <div style={S.shell}>
//       {isMobile && sidebarOpen && (
//         <div onClick={() => setSidebarOpen(false)}
//           style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", zIndex: 200 }} />
//       )}

//       {/* TOP BAR */}
//       <header style={S.topbar}>
//         <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//           {isMobile && (
//             <button onClick={() => setSidebarOpen(o => !o)}
//               style={{ background: "rgba(255,255,255,.15)", border: "none", color: "#fff",
//                 borderRadius: 7, padding: "6px 10px", fontSize: 18, cursor: "pointer", lineHeight: 1 }}>
//               ☰
//             </button>
//           )}
//           <div style={S.logoBadge}>मे</div>
//           <div>
//             <div style={{ fontWeight: 800, fontSize: isMobile ? 13 : 15, letterSpacing: .5 }}>MERURAM</div>
//             {!isMobile && <div style={{ fontSize: 9, color: "#93c5fd", letterSpacing: 3 }}>MEMBER</div>}
//           </div>
//         </div>
//         <div style={{ display: "flex", alignItems: "center", gap: isMobile ? 6 : 12 }}>
//           <span style={{ ...S.rankBadge, display: isMobile ? "none" : undefined }}>🏆 {m.rank?.toUpperCase()}</span>
//           <span style={{ fontSize: isMobile ? 11 : 12, color: "#ddd", maxWidth: isMobile ? 110 : "none", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//             {m.receiver_name}
//           </span>
//           <button style={S.logoutBtn} onClick={() => { logout(); navigate("/admin/login"); }}>
//             {isMobile ? "Exit" : "Logout"}
//           </button>
//         </div>
//       </header>

//       <div style={{ display: "flex", flex: 1, position: "relative" }}>
//         {/* SIDEBAR */}
//         <nav style={{
//           ...S.sidebar,
//           ...(isMobile ? {
//             position: "fixed", top: 0, left: 0, bottom: 0, zIndex: 300,
//             width: 230, transform: sidebarOpen ? "translateX(0)" : "translateX(-100%)",
//             transition: "transform .25s ease", overflowY: "auto", paddingTop: 56,
//           } : {})
//         }}>
//           {NAV.map(n => (
//             <div key={n.key}>
//               <div style={{ ...S.navItem, ...(tab === n.key && !subTab && !n.children ? S.navActive : {}) }}
//                 onClick={() => n.children ? setOpenNav(p => ({ ...p, [n.key]: !p[n.key] })) : goTo(n.key)}>
//                 <span style={{ flex: 1 }}>{n.label}</span>
//                 {n.children && <span style={{ fontSize: 10, opacity: .6 }}>{openNav[n.key] ? "▾" : "▸"}</span>}
//               </div>
//               {n.children && openNav[n.key] && n.children.map(child => (
//                 <div key={child} style={{ ...S.navSub, ...(subTab === child ? S.navSubActive : {}) }}
//                   onClick={() => goTo(n.key, child)}>{child}</div>
//               ))}
//             </div>
//           ))}
//           <div style={S.navItem} onClick={() => { logout(); navigate("/admin/login"); }}>🚪 Logout</div>
//         </nav>

//         {/* CONTENT */}
//         <main style={{ ...S.content, padding: isMobile ? 12 : 20 }}>

//           {/* ══════════ DASHBOARD ══════════ */}
//           {tab === "dashboard" && !subTab && (
//             <div>
//               <PageHead title="My Dashboard" />
//               <div style={{ ...S.kpiGrid, gridTemplateColumns: isMobile ? "repeat(2,1fr)" : "repeat(auto-fill, minmax(140px, 1fr))" }}>
//                 {[
//                   { label: "Wallet Balance", val: inr(m.wallet_balance), icon: "💰", bg: "#065f46" },
//                   { label: "Direct Members", val: stats.direct, icon: "👤", bg: "#1e40af" },
//                   { label: "Total Team", val: stats.total_team, icon: "👥", bg: "#7f1d1d" },
//                   { label: "Total Income", val: inr(totalIncome), icon: "📈", bg: "#4c1d95" },
//                 ].map(c => (
//                   <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
//                     <div style={{ fontSize: 22 }}>{c.icon}</div>
//                     <div style={{ fontSize: 20, fontWeight: 800 }}>{c.val}</div>
//                     <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
//                   </div>
//                 ))}
//               </div>
//               <SectionTitle>💹 Level Income at a Glance</SectionTitle>
//               <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
//                 {[1, 2, 3, 4, 5, 6].map(l => {
//                   const found = levelIncome.find(li => li.level === l);
//                   return (
//                     <div key={l} style={{ background: PIE_COLORS[l - 1], color: "#fff", borderRadius: 10, padding: "12px 16px", minWidth: 80, textAlign: "center", boxShadow: "0 2px 6px rgba(0,0,0,.15)", flex: "1 1 80px" }}>
//                       <div style={{ fontSize: 10, opacity: .8 }}>Level {l} · ₹{LEVEL_RATE[l]}/join</div>
//                       <div style={{ fontSize: 17, fontWeight: 800 }}>{inr(found?.total || 0)}</div>
//                       <div style={{ fontSize: 10, opacity: .8 }}>{found?.count || 0} members</div>
//                     </div>
//                   );
//                 })}
//               </div>
//               <div style={{ ...S.card, marginBottom: 16 }}>
//                 <div style={S.cardHead}>📊 My Level-wise Earnings Chart</div>
//                 <div style={{ padding: 16 }}>
//                   <ResponsiveContainer width="100%" height={180}>
//                     <BarChart data={chartData}>
//                       <XAxis dataKey="name" />
//                       <YAxis />
//                       <Tooltip formatter={v => inr(v)} />
//                       <Bar dataKey="earned" fill="#1e3a8a" radius={[4, 4, 0, 0]} name="Earned" />
//                     </BarChart>
//                   </ResponsiveContainer>
//                 </div>
//               </div>
//               <div style={S.card}>
//                 <div style={S.cardHead}>🔗 Referral Link</div>
//                 <div style={{ padding: "12px 16px", display: "flex", gap: 8, alignItems: isMobile ? "stretch" : "center", flexWrap: "wrap", flexDirection: isMobile ? "column" : "row" }}>
//                   <input readOnly style={{ ...S.input, flex: 1, background: "#f8fafc", color: "#475569", fontSize: 12, minWidth: 0 }}
//                     value={data.referral_link} />
//                   <button style={{ ...S.btn, background: "#1e3a8a" }}
//                     onClick={() => { navigator.clipboard.writeText(data.referral_link); toast.success("Copied!"); }}>Copy</button>
//                   <button style={{ ...S.btn, background: "#25D366" }}
//                     onClick={() => whatsapp(m.receiver_mobile || "", `🎉 Join me on Meruram Lucky Draw!\n\nUse my referral link:\n${data.referral_link}\n\nGet exciting rewards when you join!`)}>
//                     📱 Share
//                   </button>
//                 </div>
//               </div>
//               <SectionTitle>👥 My Direct Members</SectionTitle>
//               {isMobile && <div style={{ fontSize: 11, color: "#94a3b8", marginBottom: 6, textAlign: "right" }}>← Swipe table to scroll →</div>}
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "Mobile", "Their Direct", "Joined", "Status"]} />
//                   <tbody>
//                     {directMembers.slice(0, 10).map((d, i) => (
//                       <tr key={d.token_number || d.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{d.receiver_coupon_no}</td>
//                         <td style={S.td}>{d.receiver_name}</td>
//                         <td style={S.td}>{d.receiver_mobile}</td>
//                         <td style={S.td}>{d.their_direct}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmt(d.created_at)}</td>
//                         <td style={S.td}><span style={d.is_approved ? S.greenBadge : S.yellowBadge}>{d.is_approved ? "Active" : "Pending"}</span></td>
//                       </tr>
//                     ))}
//                     {directMembers.length === 0 && (
//                       <tr><td colSpan={7} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 24 }}>
//                         No direct members yet. Share your referral link!
//                       </td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ LEVEL WISE REPORT ══════════ */}
//           {subTab === "Level Wise Report" && (
//             <div>
//               <PageHead title="📊 Level Wise Report" />
//               <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
//                 {[["Direct Members", stats.direct, "#1e40af"], ["Indirect Members", stats.total_team - stats.direct, "#7c3aed"], ["Total Team", stats.total_team, "#065f46"]].map(([label, val, bg]) => (
//                   <div key={label} style={{ ...S.kpiCard, background: bg, flex: 1, minWidth: 140 }}>
//                     <div style={{ fontSize: 26, fontWeight: 800 }}>{val}</div>
//                     <div style={{ fontSize: 12, opacity: .85 }}>{label}</div>
//                   </div>
//                 ))}
//               </div>

//               {/* Level 1 — Direct */}
//               <SectionTitle>👤 Level 1 — Your Direct Members ({directMembers.length})</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "Mobile", "Connected By", "Their Direct", "Joined At", "Status", "WA"]} />
//                   <tbody>
//                     {directMembers.map((d, i) => (
//                       <tr key={d.token_number || d.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{d.receiver_coupon_no}</td>
//                         <td style={S.td}>{d.receiver_name}</td>
//                         <td style={S.td}>{d.receiver_mobile}</td>
//                         <td style={{ ...S.td, color: "#16a34a", fontWeight: 600 }}>
//                           {m.receiver_name} ({m.receiver_coupon_no}) ← You
//                         </td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>{d.their_direct}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(d.created_at)}</td>
//                         <td style={S.td}><span style={d.is_approved ? S.greenBadge : S.yellowBadge}>{d.is_approved ? "Active" : "Pending"}</span></td>
//                         <td style={S.td}>
//                           <button style={{ ...S.btn, background: "#25D366", padding: "4px 8px", fontSize: 12 }}
//                             onClick={() => whatsapp(d.receiver_mobile, `Namaste ${d.receiver_name}! Meruram Lucky Draw update. Login: ${COMPANY_URL}`)}>📱</button>
//                         </td>
//                       </tr>
//                     ))}
//                     {directMembers.length === 0 && <tr><td colSpan={9} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No direct members yet</td></tr>}
//                   </tbody>
//                 </table>
//               </div>

//               {/* ★ FIX 1: Levels 2–6 — Number(t.lvl) handles both string "2" and number 2 from MySQL */}
//               {[2, 3, 4, 5, 6].map(lvl => {
//                 const members = allTeam.filter(t => Number(t.lvl) === lvl);
//                 if (members.length === 0) return null;
//                 return (
//                   <div key={lvl}>
//                     <SectionTitle>🔗 Level {lvl} — Indirect Members ({members.length}) · Earn ₹{LEVEL_RATE[lvl]} per join</SectionTitle>
//                     <div style={S.tableWrap}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Coupon", "Name", "Mobile", "Connected Via (Sponsor)", "Rank", "Joined At", "Status"]} />
//                         <tbody>
//                           {members.map((member, i) => {
//                             const sponsorInTeam = allTeam.find(t => t.token_number === member.referred_by);
//                             const sponsorInDirect = directMembers.find(d => d.token_number === member.referred_by);
//                             const sponsor = sponsorInTeam || sponsorInDirect;
//                             const sponsorLabel = sponsor
//                               ? `${sponsor.receiver_name} (${sponsor.receiver_coupon_no})`
//                               : member.referred_by ? `Token #${member.referred_by}` : "—";
//                             return (
//                               <tr key={member.token_number} style={i % 2 === 0 ? S.trEven : {}}>
//                                 <td style={S.td}>{i + 1}</td>
//                                 <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{member.receiver_coupon_no}</td>
//                                 <td style={S.td}>{member.receiver_name}</td>
//                                 <td style={S.td}>{member.receiver_mobile}</td>
//                                 <td style={{ ...S.td, color: "#7c3aed", fontWeight: 600 }}>{sponsorLabel}</td>
//                                 <td style={S.td}><span style={S.pill}>{member.rank || "member"}</span></td>
//                                 <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(member.created_at)}</td>
//                                 <td style={S.td}><span style={member.is_approved ? S.greenBadge : S.yellowBadge}>{member.is_approved ? "Active" : "Pending"}</span></td>
//                               </tr>
//                             );
//                           })}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 );
//               })}

//               {allTeam.length === 0 && (
//                 <div style={{ textAlign: "center", padding: 40, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0", marginTop: 12 }}>
//                   No indirect members yet. Your direct members need to start referring.
//                 </div>
//               )}
//             </div>
//           )}

//           {/* ══════════ MY DIRECT TREE ══════════ */}
//           {subTab === "My Direct Tree" && (
//             <div>
//               <PageHead title="🌳 My Direct Tree" />
//               <div style={{ ...S.card, padding: isMobile ? 12 : 20, overflowX: "auto" }}>
//                 <div style={{ display: "flex", justifyContent: "center", minWidth: isMobile ? 300 : Math.max(400, directMembers.length * 130) }}>
//                   <TreeBoxNode
//                     name={m.receiver_name}
//                     coupon={m.receiver_coupon_no}
//                     isRoot
//                     subCount={directMembers.length}
//                     children={directMembers.map(d => ({
//                       name: d.receiver_name,
//                       coupon: d.receiver_coupon_no,
//                       mobile: d.receiver_mobile,
//                       isApproved: !!d.is_approved,
//                       subCount: d.their_direct,
//                     }))}
//                   />
//                 </div>
//               </div>
//               <p style={{ fontSize: 12, color: "#64748b", marginTop: 10, textAlign: "center" }}>
//                 Shows your direct referrals (Level 1). Number below each node = their own direct count.
//               </p>
//             </div>
//           )}

//           {/* ══════════ INDIRECT TREE — ★ FIX 2: fixed buildTree, shows all 6 levels ══════════ */}
//           {subTab === "Indirect Tree" && (
//             <div>
//               <PageHead title="🌐 My Full Network Tree (All 6 Levels)" />
//               {allTeam.length === 0 && directMembers.length === 0 ? (
//                 <div style={{ textAlign: "center", padding: 60, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0" }}>
//                   <div style={{ fontSize: 40, marginBottom: 12 }}>🌐</div>
//                   <div style={{ fontWeight: 700 }}>No team members yet</div>
//                   <div style={{ fontSize: 12, marginTop: 8 }}>Share your referral link to build your network</div>
//                 </div>
//               ) : (
//                 <>
//                   <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
//                     {[1, 2, 3, 4, 5, 6].map(lvl => {
//                       const count = allTeam.filter(t => Number(t.lvl) === lvl).length;
//                       return (
//                         <div key={lvl} style={{ background: PIE_COLORS[lvl - 1], color: "#fff", borderRadius: 8, padding: "10px 14px", minWidth: 90, textAlign: "center", flex: 1 }}>
//                           <div style={{ fontSize: 10, opacity: .8 }}>Level {lvl}</div>
//                           <div style={{ fontSize: 22, fontWeight: 800 }}>{count}</div>
//                           <div style={{ fontSize: 10, opacity: .8 }}>members</div>
//                         </div>
//                       );
//                     })}
//                   </div>
//                   <div style={{ ...S.card, padding: isMobile ? 8 : 16, maxHeight: isMobile ? 400 : 600, overflowY: "auto" }}>
//                     <ExpandableTreeNode node={buildTree()} depth={0} isRoot />
//                   </div>
//                   <div style={{ display: "flex", gap: 10, marginTop: 10, flexWrap: "wrap" }}>
//                     {PIE_COLORS.map((c, i) => (
//                       <div key={i} style={{ display: "flex", alignItems: "center", gap: 5 }}>
//                         <div style={{ width: 12, height: 12, borderRadius: 3, background: c }} />
//                         <span style={{ fontSize: 11, color: "#64748b" }}>Level {i + 1}</span>
//                       </div>
//                     ))}
//                     <div style={{ fontSize: 11, color: "#94a3b8", marginLeft: "auto" }}>Click ▶ to expand • Shows up to 6 levels</div>
//                   </div>
//                 </>
//               )}
//             </div>
//           )}

//           {/* ══════════ DATE WISE BUSINESS — ★ FIX 4: pass data as props, no duplicate API call ══════════ */}
//           {subTab === "Date Wise Business" && (
//             <DateWiseBusiness directMembers={directMembers} allTeam={allTeam} />
//           )}

//           {/* ══════════ DIRECT INCOME ══════════ */}
//           {subTab === "Direct Income" && (
//             <div>
//               <PageHead title="💹 Direct Income Summary" />
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["S.No", "Id No", "Member Name", "Trade Income", "Direct Income", "Level Income", "Salary Income", "Total Income"]} />
//                   <tbody>
//                     <tr style={S.trEven}>
//                       <td style={S.td}>1</td>
//                       <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{m.receiver_coupon_no}</td>
//                       <td style={S.td}>{m.receiver_name}</td>
//                       <td style={S.td}>₹0.00</td>
//                       <td style={{ ...S.td, color: "#16a34a", fontWeight: 700 }}>{inr(stats.direct * LEVEL_RATE[1])}</td>
//                       <td style={{ ...S.td, color: "#7c3aed", fontWeight: 700 }}>{inr(totalIncome)}</td>
//                       <td style={S.td}>{inr(data.salary?.amount || 0)}</td>
//                       <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 15 }}>
//                         {inr(stats.direct * LEVEL_RATE[1] + totalIncome + (data.salary?.amount || 0))}
//                       </td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ LEVEL INCOME ══════════ */}
//           {subTab === "Level Income" && (
//             <div>
//               <PageHead title="📈 Level Income — Detailed" />
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Date", "Level", "Member Name", "Coupon", "Mobile", "Amount"]} />
//                   <tbody>
//                     {levelPayout.map((p, i) => (
//                       <tr key={i} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(p.created_at)}</td>
//                         <td style={S.td}>
//                           <span style={{ ...S.pill, background: PIE_COLORS[(p.level - 1) % 6] + "22", color: PIE_COLORS[(p.level - 1) % 6], border: `1px solid ${PIE_COLORS[(p.level - 1) % 6]}` }}>
//                             L{p.level}
//                           </span>
//                         </td>
//                         <td style={{ ...S.td, fontWeight: 600 }}>{p.from_name || "—"}</td>
//                         <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700 }}>{p.from_coupon || p.from_token}</td>
//                         <td style={{ ...S.td, fontSize: 11, color: "#64748b" }}>{p.from_mobile || "—"}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(p.amount)}</td>
//                       </tr>
//                     ))}
//                     {levelPayout.length === 0 && (
//                       <tr><td colSpan={7} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 32 }}>No income credited yet</td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ TOTAL PAYOUT BY LEVEL ══════════ */}
//           {subTab === "Total Payout by Level" && (
//             <div>
//               <PageHead title="💸 Total Payout — Level-wise Breakdown" />
//               <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
//                 {[1, 2, 3, 4, 5, 6].map(l => {
//                   const found = totalPayoutByLevel.find(li => li.level === l);
//                   const earned = Number(found?.total || 0);
//                   return (
//                     <div key={l} style={{ background: "#fff", border: `2px solid ${PIE_COLORS[l - 1]}`, borderRadius: 10, padding: "14px 18px", minWidth: 90, flex: "1 1 90px", textAlign: "center" }}>
//                       <div style={{ fontSize: 11, color: "#64748b" }}>Level {l}</div>
//                       <div style={{ fontSize: 11, color: "#94a3b8" }}>₹{LEVEL_RATE[l]}/join</div>
//                       <div style={{ fontSize: 20, fontWeight: 800, color: PIE_COLORS[l - 1], margin: "6px 0" }}>{inr(earned)}</div>
//                       <div style={{ fontSize: 11, color: "#64748b" }}>{found?.count || 0} payouts</div>
//                     </div>
//                   );
//                 })}
//               </div>
//               <SectionTitle>Payout Summary Table</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["Level", "Rate/Join ₹", "Members Paid", "Total Amount Received", "% of Total Earnings"]} />
//                   <tbody>
//                     {[1, 2, 3, 4, 5, 6].map((level, i) => {
//                       const found = totalPayoutByLevel.find(l => l.level === level);
//                       const earned = Number(found?.total || 0);
//                       const pct = totalIncome > 0 ? ((earned / totalIncome) * 100).toFixed(1) : "0";
//                       return (
//                         <tr key={level} style={i % 2 === 0 ? S.trEven : {}}>
//                           <td style={S.td}><b>Level {level}</b> {level === 1 ? "🔴 Direct" : level <= 3 ? "🟡 Close" : "🟢 Deep"}</td>
//                           <td style={S.td}>₹{LEVEL_RATE[level]}</td>
//                           <td style={S.td}>{found?.count || 0}</td>
//                           <td style={{ ...S.td, fontWeight: 700, color: earned > 0 ? "#16a34a" : "#94a3b8", fontSize: 14 }}>
//                             {earned > 0 ? inr(earned) : "₹0.00"}
//                           </td>
//                           <td style={S.td}>
//                             <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                               <div style={{ flex: 1, height: 8, background: "#f1f5f9", borderRadius: 99, overflow: "hidden" }}>
//                                 <div style={{ height: "100%", width: `${Math.min(Number(pct), 100)}%`, background: PIE_COLORS[i], borderRadius: 99, transition: "width .5s" }} />
//                               </div>
//                               <span style={{ fontSize: 11, color: "#64748b", minWidth: 32 }}>{pct}%</span>
//                             </div>
//                           </td>
//                         </tr>
//                       );
//                     })}
//                     <tr style={{ background: "#f0fdf4" }}>
//                       <td style={{ ...S.td, fontWeight: 800 }} colSpan={2}>GRAND TOTAL</td>
//                       <td style={{ ...S.td, fontWeight: 700 }}>{totalPayoutByLevel.reduce((s, l) => s + l.count, 0)}</td>
//                       <td style={{ ...S.td, fontWeight: 800, color: "#15803d", fontSize: 16 }}>{inr(totalIncome)}</td>
//                       <td style={S.td}><span style={S.greenBadge}>100%</span></td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//               <SectionTitle>📋 Detailed — Who Joined & Earned Me Commission</SectionTitle>
//               <p style={{ fontSize: 12, color: "#64748b", marginBottom: 10 }}>
//                 Each row = one join event. Level 1 = your direct referral. Level 2–6 = their downline under your network.
//               </p>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Date", "Level", "Member Name", "Coupon", "Mobile", "Commission", "Note"]} />
//                   <tbody>
//                     {levelPayout.map((p, i) => (
//                       <tr key={i} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmt(p.created_at)}</td>
//                         <td style={S.td}>
//                           <span style={{ ...S.pill, background: PIE_COLORS[(p.level - 1) % 6] + "22", color: PIE_COLORS[(p.level - 1) % 6] }}>L{p.level}</span>
//                         </td>
//                         <td style={{ ...S.td, fontWeight: 600 }}>{p.from_name || "—"}</td>
//                         <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 600 }}>{p.from_coupon || p.from_token}</td>
//                         <td style={{ ...S.td, fontSize: 11, color: "#64748b" }}>{p.from_mobile || "—"}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(p.amount)}</td>
//                         <td style={{ ...S.td, fontSize: 11, color: "#64748b" }}>
//                           {p.level === 1 ? "Your direct referral joined" : `Level ${p.level} downline joined`}
//                         </td>
//                       </tr>
//                     ))}
//                     {levelPayout.length === 0 && (
//                       <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 32 }}>
//                         No commission history yet. Start referring!
//                       </td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ SALARY ══════════ */}
//           {subTab === "Salary" && (
//             <div>
//               <PageHead title="💰 Salary Details" />
//               <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
//                 <div style={{ ...S.card, padding: 20, textAlign: "center", minWidth: "min(180px, 45%)" }}>
//                   <div style={{ fontSize: 11, color: "#64748b" }}>Current Rank</div>
//                   <div style={{ fontSize: 22, fontWeight: 800, color: "#1e3a8a", margin: "8px 0" }}>{m.rank?.toUpperCase()}</div>
//                 </div>
//                 <div style={{ ...S.card, padding: 20, textAlign: "center", minWidth: "min(180px, 45%)" }}>
//                   <div style={{ fontSize: 11, color: "#64748b" }}>This Month's Salary</div>
//                   <div style={{ fontSize: 22, fontWeight: 800, color: "#16a34a", margin: "8px 0" }}>{inr(data.salary?.amount || 0)}</div>
//                   <span style={data.salary?.is_approved ? S.greenBadge : S.yellowBadge}>
//                     {data.salary?.is_approved ? "Paid ✅" : data.salary ? "Pending" : "Not Generated"}
//                   </span>
//                 </div>
//               </div>
//               <div style={{ ...S.card, padding: 16 }}>
//                 <div style={S.cardHead}>Rank Salary Chart</div>
//                 <div style={{ padding: 16 }}>
//                   {[["Member", 0], ["Silver", 1000], ["Gold", 3000], ["Platinum", 7000], ["Diamond", 15000]].map(([rank, amt]) => (
//                     <div key={rank} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #f1f5f9", alignItems: "center" }}>
//                       <span style={{ fontWeight: 600 }}>
//                         {rank.toLowerCase() === m.rank?.toLowerCase() ? `✅ ${rank} ← You` : rank}
//                       </span>
//                       <span style={{ fontWeight: 700, color: amt > 0 ? "#16a34a" : "#94a3b8" }}>
//                         {amt > 0 ? inr(amt) + "/month" : "No salary"}
//                       </span>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ WALLET REPORT ══════════ */}
//           {subTab === "Wallet Report" && (
//             <div>
//               <PageHead title="📊 Wallet Report" />
//               <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
//                 {[["Earning Wallet", m.wallet_balance, "#1e3a8a"], ["Salary Wallet", data.salary?.amount || 0, "#065f46"], ["Total Withdrawn", recentTxn.filter(t => t.type === "debit").reduce((s, t) => s + Number(t.amount), 0), "#7f1d1d"]].map(([label, val, bg]) => (
//                   <div key={label} style={{ ...S.kpiCard, background: bg, flex: 1, minWidth: 150 }}>
//                     <div style={{ fontSize: 11, opacity: .8 }}>{label}</div>
//                     <div style={{ fontSize: 20, fontWeight: 800 }}>{inr(val)}</div>
//                   </div>
//                 ))}
//               </div>
//               <SectionTitle>Recent Transactions</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Date", "Type", "Description", "Amount"]} />
//                   <tbody>
//                     {recentTxn.map((t, i) => (
//                       <tr key={t.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(t.created_at)}</td>
//                         <td style={S.td}><span style={t.type === "credit" ? S.greenBadge : S.redBadge}>{t.type}</span></td>
//                         <td style={S.td}>{t.description}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: t.type === "credit" ? "#16a34a" : "#dc2626" }}>
//                           {t.type === "credit" ? "+" : "−"}{inr(t.amount)}
//                         </td>
//                       </tr>
//                     ))}
//                     {recentTxn.length === 0 && <tr><td colSpan={5} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No transactions yet</td></tr>}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ WITHDRAWAL ══════════ */}
//           {subTab === "Withdrawal" && (
//             <div>
//               <PageHead title="💸 Request Withdrawal" />
//               <div style={{ ...S.card, maxWidth: "min(480px, 100%)" }}>
//                 <div style={S.cardHead}>Withdrawal Request</div>
//                 <div style={{ padding: "16px" }}>
//                   <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 8, padding: 14, marginBottom: 16, textAlign: "center" }}>
//                     <div style={{ fontSize: 11, color: "#15803d" }}>Available Balance</div>
//                     <div style={{ fontSize: 26, fontWeight: 900, color: "#15803d" }}>{inr(m.wallet_balance)}</div>
//                   </div>
//                   <div style={{ marginBottom: 12 }}>
//                     <label style={S.label}>Amount (₹) *</label>
//                     <input style={S.input} type="number" value={withdrawForm.amount}
//                       onChange={e => setWithdrawForm({ ...withdrawForm, amount: e.target.value })} />
//                   </div>
//                   <div style={{ marginBottom: 16 }}>
//                     <label style={S.label}>Method *</label>
//                     <select style={S.input} value={withdrawForm.method}
//                       onChange={e => setWithdrawForm({ ...withdrawForm, method: e.target.value })}>
//                       <option value="upi">UPI</option>
//                       <option value="bank">Bank Transfer</option>
//                     </select>
//                   </div>
//                   <button style={{ ...S.btn, background: "#1e3a8a", width: "100%", padding: 12, fontSize: 14 }}
//                     onClick={submitWithdraw}>Submit Withdrawal Request</button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ WITHDRAWAL DETAIL ══════════ */}
//           {subTab === "Withdrawal Detail" && (
//             <div>
//               <PageHead title="🏦 Bank / UPI Details" />
//               <div style={{ ...S.card, maxWidth: "min(480px, 100%)" }}>
//                 <div style={S.cardHead}>Payment Details for Withdrawal</div>
//                 <div style={{ padding: "16px" }}>
//                   {[["Bank Name", "bank_name"], ["Account Number", "account_number"], ["IFSC Code", "ifsc"], ["UPI ID", "upi_id"]].map(([label, key]) => (
//                     <div key={key} style={{ marginBottom: 12 }}>
//                       <label style={S.label}>{label}</label>
//                       <input style={S.input} value={bankForm[key]}
//                         onChange={e => setBankForm({ ...bankForm, [key]: e.target.value })} />
//                     </div>
//                   ))}
//                   <button style={{ ...S.btn, background: "#1e3a8a", width: "100%", padding: 12 }} onClick={saveBank}>
//                     Save Payment Details
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ RAISE TICKET ══════════ */}
//           {subTab === "Raise Ticket" && (
//             <div>
//               <PageHead title="🎫 Raise Support Ticket" />
//               <div style={{ ...S.card, maxWidth: "min(560px, 100%)" }}>
//                 <div style={S.cardHead}>Submit a Ticket</div>
//                 <div style={{ padding: "16px" }}>
//                   {[["Username", m.receiver_coupon_no, true], ["Name", m.receiver_name, true], ["Mobile No", m.receiver_mobile || "", true]].map(([label, val, ro]) => (
//                     <div key={label} style={{ marginBottom: 12 }}>
//                       <label style={S.label}>{label} *</label>
//                       <input style={{ ...S.input, background: ro ? "#f8fafc" : "#fff" }} value={val} readOnly={ro} />
//                     </div>
//                   ))}
//                   <div style={{ marginBottom: 12 }}>
//                     <label style={S.label}>Nature of Grievance *</label>
//                     <select style={S.input} value={ticketForm.nature}
//                       onChange={e => setTicketForm({ ...ticketForm, nature: e.target.value })}>
//                       <option>Support</option><option>Technical</option><option>Payment</option><option>Other</option>
//                     </select>
//                   </div>
//                   <div style={{ marginBottom: 16 }}>
//                     <label style={S.label}>Description *</label>
//                     <textarea style={{ ...S.input, height: 90, resize: "vertical" }}
//                       value={ticketForm.description}
//                       onChange={e => setTicketForm({ ...ticketForm, description: e.target.value })}
//                       placeholder="Describe your issue in detail..." />
//                   </div>
//                   <button style={{ ...S.btn, background: "#1e3a8a", width: "100%", padding: 12 }}
//                     onClick={() => {
//                       if (!ticketForm.description) { toast.error("Please enter description"); return; }
//                       const msg = `🛑 Support Ticket - ${COMPANY}\n\n👤 Name: ${m.receiver_name}\n🆔 ID: ${m.receiver_coupon_no}\n📱 Mobile: ${m.receiver_mobile || "N/A"}\n📌 Nature: ${ticketForm.nature}\n\n📝 Issue:\n${ticketForm.description}\n\n📅 Date: ${new Date().toLocaleString("en-IN")}`;
//                       window.open("https://wa.me/918275547499?text=" + encodeURIComponent(msg), "_blank");
//                       toast.success("Redirecting to WhatsApp Support...");
//                       setTicketForm({ nature: "Support", description: "" });
//                     }}>
//                     Submit Ticket via WhatsApp 📱
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ MY PROFILE ══════════ */}
//           {subTab === "My Profile" && (
//             <div>
//               <PageHead title="👤 My Profile" />
//               <div style={{ ...S.card, maxWidth: "min(600px, 100%)" }}>
//                 <div style={S.cardHead}>Profile Details</div>
//                 <div style={{ padding: 24 }}>
//                   {[
//                     ["Full Name", m.receiver_name],
//                     ["User ID / Coupon", m.receiver_coupon_no],
//                     ["Mobile Number", m.receiver_mobile],
//                     ["Joining Date", fmt(m.created_at)],
//                     ["Current Rank", m.rank?.toUpperCase()],
//                     ["Wallet Balance", inr(m.wallet_balance)],
//                     ["Direct Members", stats.direct],
//                     ["Total Team", stats.total_team],
//                   ].map(([label, value]) => (
//                     <div key={label} style={{ display: "flex", justifyContent: "space-between", padding: "12px 0", borderBottom: "1px solid #f1f5f9" }}>
//                       <span style={{ color: "#64748b" }}>{label}</span>
//                       <span style={{ fontWeight: 700 }}>{value || "—"}</span>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ WELCOME LETTER ══════════ */}
//           {subTab === "Welcome Letter" && (
//             <div>
//               <PageHead title="📄 Welcome Letter" />
//               <div style={{ ...S.card, maxWidth: "min(600px, 100%)" }}>
//                 <div style={S.cardHead}>Official Welcome Letter — Meruram</div>
//                 <div style={{ padding: 24 }}>
//                   <p style={{ fontWeight: 700, marginBottom: 4 }}>Welcome to {COMPANY}!</p>
//                   <p style={{ fontStyle: "italic", color: "#64748b", marginBottom: 16 }}>Dear {m.receiver_name},</p>
//                   <p style={{ fontSize: 13, lineHeight: 1.8, color: "#475569", marginBottom: 20 }}>
//                     We are delighted to have you as a member of our growing Meruram family. Participate, refer friends, and earn exciting rewards at every level.
//                     <br /><br />
//                     Visit us at: <a href={COMPANY_URL} style={{ color: "#ea580c", fontWeight: 600 }}>{COMPANY_URL}</a>
//                   </p>
//                   <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden" }}>
//                     {[["Member Name", m.receiver_name], ["Member ID / Coupon", m.receiver_coupon_no],
//                       ["Joining Date", fmt(m.created_at)], ["Current Rank", m.rank?.toUpperCase()],
//                       ["Wallet Balance", inr(m.wallet_balance)]].map(([k, v], idx) => (
//                       <div key={k} style={{ display: "flex", padding: "11px 16px", borderBottom: "1px solid #e2e8f0", background: idx % 2 === 0 ? "#fff" : "#f8fafc" }}>
//                         <div style={{ width: 180, color: "#64748b", fontSize: 13 }}>{k}</div>
//                         <div style={{ fontWeight: 700, fontSize: 13 }}>: {v}</div>
//                       </div>
//                     ))}
//                   </div>
//                   <div style={{ marginTop: 20, padding: 16, background: "#fefce8", border: "1px solid #fde68a", borderRadius: 8, fontSize: 12, color: "#854d0e" }}>
//                     <strong>Note:</strong> Keep your login credentials safe. Contact support if you need assistance.
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ CHANGE PASSWORD — ★ FIX 3: isolated component with own state ══════════ */}
//           {subTab === "Change Password" && (
//             <ChangePasswordPanel memberToken={m.token_number} couponNo={m.receiver_coupon_no} />
//           )}

//           {/* Fallback */}
//           {tab !== "dashboard" && !subTab && (
//             <div style={{ padding: 40, textAlign: "center", color: "#94a3b8" }}>
//               <div style={{ fontSize: 32, marginBottom: 10 }}>👆</div>
//               Tap the menu (☰) to navigate
//             </div>
//           )}
//         </main>
//       </div>

//       {/* ── MOBILE BOTTOM NAV ── */}
//       {isMobile && (
//         <nav style={{
//           position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 500,
//           background: "#1e3a8a", display: "flex", borderTop: "2px solid #1d4ed8",
//           boxShadow: "0 -2px 12px rgba(0,0,0,.3)",
//         }}>
//           {[
//             { icon: "📊", label: "Home", action: () => goTo("dashboard") },
//             { icon: "👥", label: "Team", action: () => { setOpenNav(p => ({ ...p, myteam: true })); setSidebarOpen(true); } },
//             { icon: "💹", label: "Income", action: () => { setOpenNav(p => ({ ...p, incentive: true })); setSidebarOpen(true); } },
//             { icon: "💰", label: "Wallet", action: () => goTo("wallet", "Wallet Report") },
//             { icon: "☰", label: "Menu", action: () => setSidebarOpen(o => !o) },
//           ].map(item => (
//             <button key={item.label} onClick={item.action}
//               style={{ flex: 1, background: "none", border: "none", color: "#bfdbfe",
//                 padding: "10px 4px 8px", cursor: "pointer", textAlign: "center",
//                 fontSize: 10, display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
//               <span style={{ fontSize: 20 }}>{item.icon}</span>
//               <span>{item.label}</span>
//             </button>
//           ))}
//         </nav>
//       )}
//       {isMobile && <div style={{ height: 64 }} />}
//     </div>
//   );
// }

// /* ══════════════════════════════════════════════════════
//    ★ FIX 3: CHANGE PASSWORD — own isolated component
//    Key reason password was failing: passwordForm lived in
//    the parent's state — any re-render (e.g. sidebar click)
//    would reset all 3 fields to "". Now it has its own state.
// ══════════════════════════════════════════════════════ */
// function ChangePasswordPanel({ memberToken, couponNo }) {
//   const [current, setCurrent] = useState("");
//   const [newPwd, setNewPwd]   = useState("");
//   const [confirm, setConfirm] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleSubmit = async () => {
//     if (!newPwd)           { toast.error("New password is required"); return; }
//     if (newPwd.length < 6) { toast.error("Password must be at least 6 characters"); return; }
//     if (newPwd !== confirm) { toast.error("Passwords do not match"); return; }
//     setLoading(true);
//     try {
//       await api.post("/mlm/member-change-password", {
//         token_number: memberToken,
//         old_password: current || undefined,
//         new_password: newPwd,
//       });
//       toast.success("✅ Password changed successfully!");
//       setCurrent(""); setNewPwd(""); setConfirm("");
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed. Please try again.");
//     }
//     setLoading(false);
//   };

//   return (
//     <div>
//       <PageHead title="🔐 Change Password" />
//       <div style={{ ...S.card, maxWidth: "min(500px, 100%)" }}>
//         <div style={S.cardHead}>Update Your Password</div>
//         <div style={{ padding: 24 }}>
//           <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: 12, marginBottom: 16, fontSize: 12, color: "#1e40af" }}>
//             💡 <strong>First time?</strong> Leave "Current Password" blank to set your password for the first time.
//           </div>
//           <div style={{ marginBottom: 12 }}>
//             <label style={S.label}>User ID (Coupon No)</label>
//             <input style={{ ...S.input, background: "#f8fafc", color: "#64748b" }} value={couponNo} readOnly />
//           </div>
//           <div style={{ marginBottom: 12 }}>
//             <label style={S.label}>Current Password <span style={{ color: "#94a3b8", fontSize: 11 }}>(leave blank if setting for first time)</span></label>
//             <input type="password" style={S.input} placeholder="Enter current password"
//               value={current} onChange={e => setCurrent(e.target.value)} />
//           </div>
//           <div style={{ marginBottom: 12 }}>
//             <label style={S.label}>New Password *</label>
//             <input type="password" style={S.input} placeholder="Minimum 6 characters"
//               value={newPwd} onChange={e => setNewPwd(e.target.value)} />
//           </div>
//           <div style={{ marginBottom: 8 }}>
//             <label style={S.label}>Confirm New Password *</label>
//             <input type="password" style={S.input} placeholder="Re-enter new password"
//               value={confirm} onChange={e => setConfirm(e.target.value)} />
//           </div>
//           {/* Live match indicator */}
//           {confirm.length > 0 && (
//             <div style={{ marginBottom: 16, fontSize: 12, fontWeight: 700, color: newPwd === confirm ? "#16a34a" : "#dc2626" }}>
//               {newPwd === confirm ? "✅ Passwords match" : "❌ Passwords do not match"}
//             </div>
//           )}
//           <button
//             style={{ ...S.btn, background: loading ? "#94a3b8" : "#1e3a8a", width: "100%", padding: 12, fontSize: 14 }}
//             onClick={handleSubmit} disabled={loading}>
//             {loading ? "Updating..." : "🔐 Update Password"}
//           </button>
//           <p style={{ fontSize: 11, color: "#94a3b8", marginTop: 12, textAlign: "center" }}>
//             Need help? <a href="https://wa.me/918275547499" target="_blank" rel="noreferrer"
//               style={{ color: "#25D366", fontWeight: 600 }}>Contact WhatsApp Support</a>
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ══════════════════════════════════════════════════════
//    ★ FIX 4: DATE WISE BUSINESS
//    Old version: made its own API call using token prop
//    Fixed: receives directMembers + allTeam as props
//    (already loaded by parent), filters client-side.
//    No extra API call, no token needed.
// ══════════════════════════════════════════════════════ */
// function DateWiseBusiness({ directMembers, allTeam }) {
//   const [from, setFrom] = useState(() => new Date(Date.now() - 7 * 86400000).toISOString().slice(0, 10));
//   const [to, setTo]     = useState(() => new Date().toISOString().slice(0, 10));

//   // Combine direct (lvl=1) + indirect (lvl 2–6)
//   const allMembers = [
//     ...directMembers.map(d => ({ ...d, lvl: 1 })),
//     ...allTeam.filter(t => Number(t.lvl) > 1),
//   ];

//   const filtered = allMembers.filter(mem => {
//     const d = mem.created_at?.slice(0, 10);
//     return d && d >= from && d <= to;
//   });

//   const grouped = {};
//   filtered.forEach(mem => {
//     const d = mem.created_at.slice(0, 10);
//     if (!grouped[d]) grouped[d] = { date: d, count: 0, levels: {} };
//     grouped[d].count++;
//     const lvl = Number(mem.lvl);
//     grouped[d].levels[lvl] = (grouped[d].levels[lvl] || 0) + 1;
//   });
//   const rows = Object.values(grouped).sort((a, b) => b.date.localeCompare(a.date));
//   const totalJoins = rows.reduce((s, r) => s + r.count, 0);

//   return (
//     <div>
//       <PageHead title="📅 Date Wise Business Report" />
//       <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap", alignItems: "flex-end" }}>
//         <div>
//           <label style={S.label}>From Date</label>
//           <input type="date" style={{ ...S.input, width: "auto" }} value={from} onChange={e => setFrom(e.target.value)} />
//         </div>
//         <div>
//           <label style={S.label}>To Date</label>
//           <input type="date" style={{ ...S.input, width: "auto" }} value={to} onChange={e => setTo(e.target.value)} />
//         </div>
//       </div>
//       <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
//         {[["Total Joins", totalJoins, "#1e3a8a"], ["Active Days", rows.length, "#065f46"], ["Avg/Day", rows.length ? Math.round(totalJoins / rows.length) : 0, "#7f1d1d"]].map(([label, val, bg]) => (
//           <div key={label} style={{ ...S.kpiCard, background: bg, flex: 1, minWidth: 130 }}>
//             <div style={{ fontSize: 24, fontWeight: 800 }}>{val}</div>
//             <div style={{ fontSize: 11, opacity: .8 }}>{label}</div>
//           </div>
//         ))}
//       </div>
//       <div style={S.tableWrap}>
//         <table style={S.table}>
//           <THead cols={["Date", "Total Joins", "L1", "L2", "L3", "L4", "L5", "L6"]} />
//           <tbody>
//             {rows.map((r, i) => (
//               <tr key={r.date} style={i % 2 === 0 ? S.trEven : {}}>
//                 <td style={{ ...S.td, fontWeight: 700 }}>{fmt(r.date)}</td>
//                 <td style={{ ...S.td, fontWeight: 800, color: "#1d4ed8", fontSize: 15 }}>{r.count}</td>
//                 {[1, 2, 3, 4, 5, 6].map(l => (
//                   <td key={l} style={{ ...S.td, color: r.levels[l] ? PIE_COLORS[l - 1] : "#cbd5e1", fontWeight: r.levels[l] ? 700 : 400 }}>
//                     {r.levels[l] || 0}
//                   </td>
//                 ))}
//               </tr>
//             ))}
//             {rows.length === 0 && (
//               <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 32 }}>
//                 No joins found in selected date range
//               </td></tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// /* ── Sub-components ── */
// function PageHead({ title, children }) {
//   return (
//     <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16, paddingBottom: 12, borderBottom: "2px solid #e2e8f0" }}>
//       <div style={{ width: 4, height: 20, background: "#ea580c", borderRadius: 99 }} />
//       <span style={{ fontWeight: 700, fontSize: 16, color: "#1e293b" }}>{title}</span>
//       {children}
//     </div>
//   );
// }
// function SectionTitle({ children }) {
//   return <div style={{ fontWeight: 700, fontSize: 13, color: "#1e3a8a", margin: "18px 0 10px", borderLeft: "4px solid #ea580c", paddingLeft: 10 }}>{children}</div>;
// }
// function THead({ cols }) {
//   return (
//     <thead>
//       <tr style={{ background: "#1e3a8a", color: "#fff" }}>
//         {cols.map(c => <th key={c} style={{ padding: "10px 12px", textAlign: "left", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}>{c}</th>)}
//       </tr>
//     </thead>
//   );
// }

// /* ── Direct Tree: box layout ── */
// function TreeBoxNode({ name, coupon, isRoot, isApproved, subCount, children = [] }) {
//   return (
//     <div style={{ textAlign: "center", margin: "0 6px" }}>
//       <div style={{
//         padding: "8px 14px",
//         background: isRoot ? "linear-gradient(135deg,#ea580c,#f97316)" : "#1e3a8a",
//         color: "#fff", borderRadius: 8, fontSize: 12, fontWeight: 700,
//         display: "inline-block", boxShadow: "0 2px 8px rgba(0,0,0,.2)", minWidth: 100,
//         border: isRoot ? "2px solid #fff" : "none",
//       }}>
//         <div>{name}</div>
//         {coupon && <div style={{ fontSize: 10, opacity: .8, marginTop: 2 }}>{coupon}</div>}
//         {subCount !== undefined && (
//           <div style={{ fontSize: 10, marginTop: 3, background: "rgba(255,255,255,.2)", borderRadius: 4, padding: "1px 4px" }}>
//             {subCount} direct
//           </div>
//         )}
//         {isApproved !== undefined && (
//           <div style={{ fontSize: 10, marginTop: 2, color: isApproved ? "#4ade80" : "#fbbf24" }}>
//             {isApproved ? "Active ✅" : "Pending ⏳"}
//           </div>
//         )}
//       </div>
//       {children.length > 0 && (
//         <>
//           <div style={{ width: 2, height: 20, background: "#94a3b8", margin: "0 auto" }} />
//           <div style={{ display: "flex", justifyContent: "center", position: "relative" }}>
//             {children.length > 1 && (
//               <div style={{ position: "absolute", top: 0, left: "10%", right: "10%", height: 2, background: "#94a3b8" }} />
//             )}
//             {children.map((child, i) => (
//               <div key={i}>
//                 <div style={{ width: 2, height: 16, background: "#94a3b8", margin: "0 auto" }} />
//                 <TreeBoxNode {...child} />
//               </div>
//             ))}
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// /* ── Expandable tree node for Indirect Tree ── */
// function ExpandableTreeNode({ node, depth = 0, isRoot = false }) {
//   const [expanded, setExpanded] = useState(depth < 2);
//   const DEPTH_COLORS = ["#1e3a8a", "#1d4ed8", "#3b82f6", "#60a5fa", "#93c5fd", "#bfdbfe"];
//   const textColors =  ["#fff",     "#fff",     "#fff",     "#fff",    "#1e3a8a", "#1e3a8a"];
//   if (!node) return null;
//   const hasChildren = node.children && node.children.length > 0;
//   return (
//     <div style={{ marginLeft: Math.min(depth * 16, 80), marginBottom: 3 }}>
//       <div onClick={() => hasChildren && setExpanded(e => !e)}
//         style={{
//           display: "flex", alignItems: "center", gap: 8, padding: "7px 12px",
//           background: DEPTH_COLORS[Math.min(depth, 5)],
//           color: textColors[Math.min(depth, 5)],
//           borderRadius: 7, cursor: hasChildren ? "pointer" : "default",
//           border: isRoot ? "2px solid #f97316" : "1px solid rgba(0,0,0,.08)",
//           userSelect: "none",
//         }}>
//         <span style={{ fontSize: 11, minWidth: 14, opacity: .8 }}>
//           {hasChildren ? (expanded ? "▼" : "▶") : "●"}
//         </span>
//         <span style={{ fontWeight: 700, fontSize: 12 }}>{node.receiver_coupon_no || node.token_number}</span>
//         <span style={{ fontSize: 12 }}>{node.receiver_name}</span>
//         {node.receiver_mobile && window.innerWidth >= 768 && (
//           <span style={{ fontSize: 11, opacity: .75, marginLeft: 4 }}>{node.receiver_mobile}</span>
//         )}
//         {isRoot && <span style={{ fontSize: 10, background: "#f97316", borderRadius: 99, padding: "1px 7px", marginLeft: 4 }}>YOU</span>}
//         {hasChildren && (
//           <span style={{ marginLeft: "auto", background: "rgba(255,255,255,.25)", borderRadius: 99, padding: "1px 8px", fontSize: 11 }}>
//             {node.children.length} ▸
//           </span>
//         )}
//         <span style={{ background: node.is_approved ? "#16a34a" : "#f59e0b", borderRadius: 99, padding: "1px 6px", fontSize: 10, color: "#fff", marginLeft: hasChildren ? 0 : "auto" }}>
//           {node.is_approved ? "✓" : "⏳"}
//         </span>
//       </div>
//       {expanded && hasChildren && (
//         <div style={{ borderLeft: "2px solid #bfdbfe", marginLeft: 16, paddingLeft: 6, marginTop: 3 }}>
//           {node.children.map(child => (
//             <ExpandableTreeNode key={child.token_number} node={child} depth={depth + 1} />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// /* ── Styles ── */
// const S = {
//   shell: { display: "flex", flexDirection: "column", minHeight: "100vh", fontFamily: "'Segoe UI', system-ui, sans-serif", fontSize: 13, background: "#f1f5f9" },
//   topbar: { background: "linear-gradient(90deg,#1e3a8a 0%,#1e40af 100%)", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", position: "sticky", top: 0, zIndex: 400, boxShadow: "0 2px 10px rgba(0,0,0,.3)" },
//   logoBadge: { width: 36, height: 36, borderRadius: 9, background: "linear-gradient(135deg,#f97316,#ea580c)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 16, color: "#fff", flexShrink: 0 },
//   rankBadge: { background: "rgba(255,255,255,.15)", border: "1px solid rgba(255,255,255,.3)", borderRadius: 99, padding: "3px 12px", fontSize: 11, fontWeight: 700, color: "#fef3c7" },
//   logoutBtn: { background: "rgba(239,68,68,.85)", border: "none", color: "#fff", padding: "6px 12px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 12, flexShrink: 0 },
//   sidebar: { width: 200, background: "#1e3a8a", minHeight: "calc(100vh - 56px)", flexShrink: 0 },
//   navItem: { color: "#bfdbfe", padding: "13px 16px", cursor: "pointer", display: "flex", alignItems: "center", fontSize: 13, borderBottom: "1px solid rgba(255,255,255,.06)", fontWeight: 500 },
//   navActive: { background: "#ea580c", color: "#fff" },
//   navSub: { color: "#93c5fd", padding: "11px 16px 11px 28px", cursor: "pointer", fontSize: 12, background: "rgba(0,0,0,.25)", borderBottom: "1px solid rgba(255,255,255,.04)" },
//   navSubActive: { background: "#ea580c", color: "#fff", fontWeight: 700 },
//   content: { flex: 1, padding: 16, overflowX: "hidden", minWidth: 0 },
//   kpiGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: 10, marginBottom: 16 },
//   kpiCard: { color: "#fff", borderRadius: 10, padding: "14px 16px", display: "flex", flexDirection: "column", gap: 4, boxShadow: "0 2px 8px rgba(0,0,0,.15)" },
//   card: { background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden" },
//   cardHead: { background: "#1e3a8a", color: "#fff", padding: "10px 16px", fontWeight: 700, fontSize: 13 },
//   tableWrap: { background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", overflowX: "auto", marginBottom: 16, WebkitOverflowScrolling: "touch" },
//   table: { width: "100%", borderCollapse: "collapse", minWidth: 480 },
//   td: { padding: "9px 10px", fontSize: 12, borderBottom: "1px solid #f1f5f9", verticalAlign: "middle", whiteSpace: "nowrap" },
//   trEven: { background: "#f8fafc" },
//   pill: { background: "#eff6ff", color: "#1d4ed8", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 600 },
//   greenBadge: { background: "#dcfce7", color: "#15803d", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   yellowBadge: { background: "#fef9c3", color: "#854d0e", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   redBadge: { background: "#fee2e2", color: "#991b1b", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   label: { display: "block", fontSize: 12, color: "#475569", marginBottom: 4, fontWeight: 600 },
//   input: { border: "1px solid #e2e8f0", padding: "9px 12px", width: "100%", fontSize: 13, borderRadius: 6, outline: "none", boxSizing: "border-box" },
//   btn: { color: "#fff", border: "none", padding: "7px 14px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13, display: "inline-flex", alignItems: "center", gap: 4 },
//   btnPrimary: { background: "#1e3a8a", color: "#fff", border: "none", padding: "9px 20px", borderRadius: 6, cursor: "pointer", fontWeight: 700, fontSize: 13 },
//   loginWrap: { minHeight: "100vh", background: "linear-gradient(135deg,#1e3a8a 0%,#1e40af 100%)", display: "flex", alignItems: "center", justifyContent: "center" },
//   loginBox: { background: "#fff", borderRadius: 14, padding: 40, width: 340, boxShadow: "0 24px 60px rgba(0,0,0,.25)" },
//   loginLogo: { width: 60, height: 60, borderRadius: 14, background: "linear-gradient(135deg,#f97316,#ea580c)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 24, color: "#fff", margin: "0 auto", boxShadow: "0 4px 16px rgba(234,88,12,.4)" },
// };





// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";
// import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
// import api from "../api";
// import toast from "react-hot-toast";

// /* ── Inject mobile meta + global CSS once ── */
// if (!document.getElementById("mlm-mobile-css")) {
//   const meta = document.createElement("meta");
//   meta.name = "viewport";
//   meta.content = "width=device-width, initial-scale=1, maximum-scale=1";
//   document.head.appendChild(meta);
//   const style = document.createElement("style");
//   style.id = "mlm-mobile-css";
//   style.textContent = `
//     * { box-sizing: border-box; }
//     body { margin: 0; overflow-x: hidden; }
//     input, select, textarea, button { font-size: 16px !important; }
//     @media (max-width: 767px) {
//       .mlm-hide-mobile { display: none !important; }
//       .mlm-table-wrap { overflow-x: auto; -webkit-overflow-scrolling: touch; }
//       .mlm-table-wrap table { min-width: 520px; }
//       .mlm-flex-col { flex-direction: column !important; }
//       .mlm-full { width: 100% !important; max-width: 100% !important; }
//     }
//   `;
//   document.head.appendChild(style);
// }

// const LEVEL_RATE = { 1: 300, 2: 150, 3: 120, 4: 90, 5: 60, 6: 30 };
// const PIE_COLORS = ["#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#06b6d4"];
// const COMPANY = "Meruram";
// const COMPANY_URL = "https://meruram.in";

// const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
// const fmt = (d) => d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—";
// const fmtTime = (d) => d ? new Date(d).toLocaleString("en-IN") : "—";
// const whatsapp = (mobile, msg) => {
//   if (!mobile) { toast.error("No mobile number!"); return; }
//   window.open(`https://wa.me/91${mobile.replace(/\D/g, "")}?text=${encodeURIComponent(msg)}`, "_blank");
// };

// const NAV = [
//   { label: "📊 Dashboard", key: "dashboard" },
//   { label: "👤 Profile", key: "profile", children: ["My Profile", "Welcome Letter", "Change Password"] },
//   { label: "👥 My Team", key: "myteam", children: ["Level Wise Report", "My Direct Tree", "Indirect Tree", "Date Wise Business"] },
//   { label: "💹 My Incentive", key: "incentive", children: ["Direct Income", "Level Income", "Total Payout by Level", "Salary"] },
//   { label: "💰 Wallet", key: "wallet", children: ["Wallet Report", "Withdrawal", "Withdrawal Detail"] },
//   { label: "🎫 Support", key: "support", children: ["Raise Ticket", "Ticket Status"] },
// ];

// /* ── Mobile detection hook ── */
// function useIsMobile() {
//   const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
//   useEffect(() => {
//     const handler = () => setIsMobile(window.innerWidth < 768);
//     window.addEventListener("resize", handler);
//     return () => window.removeEventListener("resize", handler);
//   }, []);
//   return isMobile;
// }

// export default function AdminDashboard() {
//   const { logout } = useAuth();
//   const navigate = useNavigate();
//   const isMobile = useIsMobile();
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [token, setToken] = useState(() => localStorage.getItem("member_token") || "");
//   const [tokenInput, setTokenInput] = useState("");
//   const [data, setData] = useState(null);
//   const [tab, setTab] = useState("dashboard");
//   const [subTab, setSubTab] = useState("");
//   const [openNav, setOpenNav] = useState({});
//   const [ticketForm, setTicketForm] = useState({ nature: "Support", description: "" });
//   const [withdrawForm, setWithdrawForm] = useState({ amount: "", method: "upi" });
//   const [bankForm, setBankForm] = useState({ bank_name: "", account_number: "", ifsc: "", upi_id: "" });

//   useEffect(() => { if (token) fetchData(); }, [token]);

//   const fetchData = async () => {
//     try {
//       const res = await api.get(`/mlm/my-stats/${token}`);
//       setData(res.data);
//     } catch { toast.error("Could not load data. Check your token."); }
//   };

//   const goTo = (t, s = "") => { setTab(t); setSubTab(s); setSidebarOpen(false); };

//   const submitWithdraw = async () => {
//     if (!withdrawForm.amount) { toast.error("Enter amount"); return; }
//     try {
//       await api.post(`/wallet/withdraw/${token}`, withdrawForm);
//       toast.success("Withdrawal request submitted!");
//       fetchData();
//     } catch (err) { toast.error(err.response?.data?.message || "Error"); }
//   };

//   const saveBank = async () => {
//     try { await api.put(`/wallet/bank/${token}`, bankForm); toast.success("Bank details saved!"); }
//     catch { toast.error("Save failed"); }
//   };

//   /* ── Login screen ── */
//   if (!token) {
//     return (
//       <div style={S.loginWrap}>
//         <div style={S.loginBox}>
//           <div style={{ textAlign: "center", marginBottom: 28 }}>
//             <div style={S.loginLogo}>मे</div>
//             <div style={{ fontWeight: 900, fontSize: 20, color: "#1e3a8a", marginTop: 10, letterSpacing: 1 }}>MERURAM</div>
//             <div style={{ fontSize: 11, color: "#94a3b8", letterSpacing: 3, marginTop: 2 }}>MEMBER</div>
//           </div>
//           <label style={S.label}>Your Member Token / Coupon No.</label>
//           <input style={S.input} placeholder="e.g. MLAB12345"
//             value={tokenInput} onChange={e => setTokenInput(e.target.value)}
//             onKeyDown={e => e.key === "Enter" && (() => { localStorage.setItem("member_token", tokenInput.trim()); setToken(tokenInput.trim()); })()}
//           />
//           <button style={{ ...S.btnPrimary, width: "100%", marginTop: 14, padding: 12 }}
//             onClick={() => { localStorage.setItem("member_token", tokenInput.trim()); setToken(tokenInput.trim()); }}>
//             Login →
//           </button>
//           <p style={{ textAlign: "center", fontSize: 12, color: "#94a3b8", marginTop: 16 }}>
//             Not a member? <a href="/register" style={{ color: "#ea580c" }}>Register here</a>
//           </p>
//         </div>
//       </div>
//     );
//   }

//   if (!data) return <div style={{ padding: 60, textAlign: "center", color: "#94a3b8", fontSize: 16 }}>Loading your dashboard...</div>;

//   const m = data.member;
//   const stats = data.stats;
//   const levelIncome = data.level_income || [];
//   const levelPayout = data.level_payout || [];
//   const directMembers = data.direct_members || [];
//   const recentTxn = data.recent_transactions || [];
//   const totalPayoutByLevel = data.total_payout_by_level || [];
//   const allTeam = data.all_team || [];
//   const totalIncome = levelIncome.reduce((s, l) => s + Number(l.total || 0), 0);

//   const chartData = [1, 2, 3, 4, 5, 6].map(l => {
//     const found = levelIncome.find(li => li.level === l);
//     return { name: `L${l}`, earned: Number(found?.total || 0), members: found?.count || 0 };
//   });

//   const buildTree = () => {
//     const map = {};
//     map[m.token_number] = { ...m, children: [] };
//     allTeam.forEach(member => {
//       map[member.token_number] = { ...member, children: [] };
//     });
//     allTeam.forEach(member => {
//       const parent = map[member.referred_by];
//       if (parent) {
//         if (!parent.children.find(c => c.token_number === member.token_number)) {
//           parent.children.push(map[member.token_number]);
//         }
//       }
//     });
//     return map[m.token_number];
//   };

//   return (
//     <div style={S.shell}>
//       {isMobile && sidebarOpen && (
//         <div onClick={() => setSidebarOpen(false)}
//           style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", zIndex: 200 }} />
//       )}

//       {/* TOP BAR */}
//       <header style={S.topbar}>
//         <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//           {isMobile && (
//             <button onClick={() => setSidebarOpen(o => !o)}
//               style={{ background: "rgba(255,255,255,.15)", border: "none", color: "#fff",
//                 borderRadius: 7, padding: "6px 10px", fontSize: 18, cursor: "pointer", lineHeight: 1 }}>
//               ☰
//             </button>
//           )}
//           <div style={S.logoBadge}>मे</div>
//           <div>
//             <div style={{ fontWeight: 800, fontSize: isMobile ? 13 : 15, letterSpacing: .5 }}>MERURAM</div>
//             {!isMobile && <div style={{ fontSize: 9, color: "#93c5fd", letterSpacing: 3 }}>MEMBER</div>}
//           </div>
//         </div>
//         <div style={{ display: "flex", alignItems: "center", gap: isMobile ? 6 : 12 }}>
//           <span style={{ ...S.rankBadge, display: isMobile ? "none" : undefined }}>🏆 {m.rank?.toUpperCase()}</span>
//           <span style={{ fontSize: isMobile ? 11 : 12, color: "#ddd", maxWidth: isMobile ? 110 : "none", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//             {m.receiver_name}
//           </span>
//           <button style={S.logoutBtn} onClick={() => { logout(); navigate("/admin/login"); }}>
//             {isMobile ? "Exit" : "Logout"}
//           </button>
//         </div>
//       </header>

//       <div style={{ display: "flex", flex: 1, position: "relative" }}>
//         {/* SIDEBAR */}
//         <nav style={{
//           ...S.sidebar,
//           ...(isMobile ? {
//             position: "fixed", top: 0, left: 0, bottom: 0, zIndex: 300,
//             width: 230, transform: sidebarOpen ? "translateX(0)" : "translateX(-100%)",
//             transition: "transform .25s ease", overflowY: "auto", paddingTop: 56,
//           } : {})
//         }}>
//           {NAV.map(n => (
//             <div key={n.key}>
//               <div style={{ ...S.navItem, ...(tab === n.key && !subTab && !n.children ? S.navActive : {}) }}
//                 onClick={() => n.children ? setOpenNav(p => ({ ...p, [n.key]: !p[n.key] })) : goTo(n.key)}>
//                 <span style={{ flex: 1 }}>{n.label}</span>
//                 {n.children && <span style={{ fontSize: 10, opacity: .6 }}>{openNav[n.key] ? "▾" : "▸"}</span>}
//               </div>
//               {n.children && openNav[n.key] && n.children.map(child => (
//                 <div key={child} style={{ ...S.navSub, ...(subTab === child ? S.navSubActive : {}) }}
//                   onClick={() => goTo(n.key, child)}>{child}</div>
//               ))}
//             </div>
//           ))}
//           <div style={S.navItem} onClick={() => { logout(); navigate("/admin/login"); }}>🚪 Logout</div>
//         </nav>

//         {/* CONTENT */}
//         <main style={{ ...S.content, padding: isMobile ? 12 : 20 }}>

//           {/* ══════════ DASHBOARD ══════════ */}
//           {tab === "dashboard" && !subTab && (
//             <div>
//               <PageHead title="My Dashboard" />
//               <div style={{ ...S.kpiGrid, gridTemplateColumns: isMobile ? "repeat(2,1fr)" : "repeat(auto-fill, minmax(140px, 1fr))" }}>
//                 {[
//                   { label: "Wallet Balance", val: inr(m.wallet_balance), icon: "💰", bg: "#065f46" },
//                   { label: "Direct Members", val: stats.direct, icon: "👤", bg: "#1e40af" },
//                   { label: "Total Team", val: stats.total_team, icon: "👥", bg: "#7f1d1d" },
//                   { label: "Total Income", val: inr(totalIncome), icon: "📈", bg: "#4c1d95" },
//                 ].map(c => (
//                   <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
//                     <div style={{ fontSize: 22 }}>{c.icon}</div>
//                     <div style={{ fontSize: 20, fontWeight: 800 }}>{c.val}</div>
//                     <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
//                   </div>
//                 ))}
//               </div>
//               <SectionTitle>💹 Level Income at a Glance</SectionTitle>
//               <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
//                 {[1, 2, 3, 4, 5, 6].map(l => {
//                   const found = levelIncome.find(li => li.level === l);
//                   return (
//                     <div key={l} style={{ background: PIE_COLORS[l - 1], color: "#fff", borderRadius: 10, padding: "12px 16px", minWidth: 80, textAlign: "center", boxShadow: "0 2px 6px rgba(0,0,0,.15)", flex: "1 1 80px" }}>
//                       <div style={{ fontSize: 10, opacity: .8 }}>Level {l} · ₹{LEVEL_RATE[l]}/join</div>
//                       <div style={{ fontSize: 17, fontWeight: 800 }}>{inr(found?.total || 0)}</div>
//                       <div style={{ fontSize: 10, opacity: .8 }}>{found?.count || 0} members</div>
//                     </div>
//                   );
//                 })}
//               </div>
//               <div style={{ ...S.card, marginBottom: 16 }}>
//                 <div style={S.cardHead}>📊 My Level-wise Earnings Chart</div>
//                 <div style={{ padding: 16 }}>
//                   <ResponsiveContainer width="100%" height={180}>
//                     <BarChart data={chartData}>
//                       <XAxis dataKey="name" />
//                       <YAxis />
//                       <Tooltip formatter={v => inr(v)} />
//                       <Bar dataKey="earned" fill="#1e3a8a" radius={[4, 4, 0, 0]} name="Earned" />
//                     </BarChart>
//                   </ResponsiveContainer>
//                 </div>
//               </div>
//               <div style={S.card}>
//                 <div style={S.cardHead}>🔗 Referral Link</div>
//                 <div style={{ padding: "12px 16px", display: "flex", gap: 8, alignItems: isMobile ? "stretch" : "center", flexWrap: "wrap", flexDirection: isMobile ? "column" : "row" }}>
//                   <input readOnly style={{ ...S.input, flex: 1, background: "#f8fafc", color: "#475569", fontSize: 12, minWidth: 0 }}
//                     value={data.referral_link} />
//                   <button style={{ ...S.btn, background: "#1e3a8a" }}
//                     onClick={() => { navigator.clipboard.writeText(data.referral_link); toast.success("Copied!"); }}>Copy</button>
//                   <button style={{ ...S.btn, background: "#25D366" }}
//                     onClick={() => whatsapp(m.receiver_mobile || "", `🎉 Join me on Meruram Lucky Draw!\n\nUse my referral link:\n${data.referral_link}\n\nGet exciting rewards when you join!`)}>
//                     📱 Share
//                   </button>
//                 </div>
//               </div>
//               <SectionTitle>👥 My Direct Members</SectionTitle>
//               {isMobile && <div style={{ fontSize: 11, color: "#94a3b8", marginBottom: 6, textAlign: "right" }}>← Swipe table to scroll →</div>}
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "Mobile", "Their Direct", "Joined", "Status"]} />
//                   <tbody>
//                     {directMembers.slice(0, 10).map((d, i) => (
//                       <tr key={d.token_number || d.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{d.receiver_coupon_no}</td>
//                         <td style={S.td}>{d.receiver_name}</td>
//                         <td style={S.td}>{d.receiver_mobile}</td>
//                         <td style={S.td}>{d.their_direct}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmt(d.created_at)}</td>
//                         <td style={S.td}><span style={d.is_approved ? S.greenBadge : S.yellowBadge}>{d.is_approved ? "Active" : "Pending"}</span></td>
//                       </tr>
//                     ))}
//                     {directMembers.length === 0 && (
//                       <tr><td colSpan={7} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 24 }}>
//                         No direct members yet. Share your referral link!
//                       </td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ LEVEL WISE REPORT ══════════ */}
//           {subTab === "Level Wise Report" && (
//             <div>
//               <PageHead title="📊 Level Wise Report" />
//               <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
//                 {[["Direct Members", stats.direct, "#1e40af"], ["Indirect Members", stats.total_team - stats.direct, "#7c3aed"], ["Total Team", stats.total_team, "#065f46"]].map(([label, val, bg]) => (
//                   <div key={label} style={{ ...S.kpiCard, background: bg, flex: 1, minWidth: 140 }}>
//                     <div style={{ fontSize: 26, fontWeight: 800 }}>{val}</div>
//                     <div style={{ fontSize: 12, opacity: .85 }}>{label}</div>
//                   </div>
//                 ))}
//               </div>

//               <SectionTitle>👤 Level 1 — Your Direct Members ({directMembers.length})</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Coupon", "Name", "Mobile", "Connected By", "Their Direct", "Joined At", "Status", "WA"]} />
//                   <tbody>
//                     {directMembers.map((d, i) => (
//                       <tr key={d.token_number || d.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{d.receiver_coupon_no}</td>
//                         <td style={S.td}>{d.receiver_name}</td>
//                         <td style={S.td}>{d.receiver_mobile}</td>
//                         <td style={{ ...S.td, color: "#16a34a", fontWeight: 600 }}>
//                           {m.receiver_name} ({m.receiver_coupon_no}) ← You
//                         </td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>{d.their_direct}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(d.created_at)}</td>
//                         <td style={S.td}><span style={d.is_approved ? S.greenBadge : S.yellowBadge}>{d.is_approved ? "Active" : "Pending"}</span></td>
//                         <td style={S.td}>
//                           <button style={{ ...S.btn, background: "#25D366", padding: "4px 8px", fontSize: 12 }}
//                             onClick={() => whatsapp(d.receiver_mobile, `Namaste ${d.receiver_name}! Meruram Lucky Draw update. Login: ${COMPANY_URL}`)}>📱</button>
//                         </td>
//                       </tr>
//                     ))}
//                     {directMembers.length === 0 && <tr><td colSpan={9} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No direct members yet</td></tr>}
//                   </tbody>
//                 </table>
//               </div>

//               {[2, 3, 4, 5, 6].map(lvl => {
//                 const members = allTeam.filter(t => Number(t.lvl) === lvl);
//                 if (members.length === 0) return null;
//                 return (
//                   <div key={lvl}>
//                     <SectionTitle>🔗 Level {lvl} — Indirect Members ({members.length}) · Earn ₹{LEVEL_RATE[lvl]} per join</SectionTitle>
//                     <div style={S.tableWrap}>
//                       <table style={S.table}>
//                         <THead cols={["#", "Coupon", "Name", "Mobile", "Connected Via (Sponsor)", "Rank", "Joined At", "Status"]} />
//                         <tbody>
//                           {members.map((member, i) => {
//                             const sponsorInTeam = allTeam.find(t => t.token_number === member.referred_by);
//                             const sponsorInDirect = directMembers.find(d => d.token_number === member.referred_by);
//                             const sponsor = sponsorInTeam || sponsorInDirect;
//                             const sponsorLabel = sponsor
//                               ? `${sponsor.receiver_name} (${sponsor.receiver_coupon_no})`
//                               : member.referred_by ? `Token #${member.referred_by}` : "—";
//                             return (
//                               <tr key={member.token_number} style={i % 2 === 0 ? S.trEven : {}}>
//                                 <td style={S.td}>{i + 1}</td>
//                                 <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{member.receiver_coupon_no}</td>
//                                 <td style={S.td}>{member.receiver_name}</td>
//                                 <td style={S.td}>{member.receiver_mobile}</td>
//                                 <td style={{ ...S.td, color: "#7c3aed", fontWeight: 600 }}>{sponsorLabel}</td>
//                                 <td style={S.td}><span style={S.pill}>{member.rank || "member"}</span></td>
//                                 <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(member.created_at)}</td>
//                                 <td style={S.td}><span style={member.is_approved ? S.greenBadge : S.yellowBadge}>{member.is_approved ? "Active" : "Pending"}</span></td>
//                               </tr>
//                             );
//                           })}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 );
//               })}

//               {allTeam.length === 0 && (
//                 <div style={{ textAlign: "center", padding: 40, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0", marginTop: 12 }}>
//                   No indirect members yet. Your direct members need to start referring.
//                 </div>
//               )}
//             </div>
//           )}

//           {/* ══════════ MY DIRECT TREE ══════════ */}
//           {subTab === "My Direct Tree" && (
//             <div>
//               <PageHead title="🌳 My Direct Tree" />
//               <div style={{ ...S.card, padding: isMobile ? 12 : 20, overflowX: "auto" }}>
//                 <div style={{ display: "flex", justifyContent: "center", minWidth: isMobile ? 300 : Math.max(400, directMembers.length * 130) }}>
//                   <TreeBoxNode
//                     name={m.receiver_name}
//                     coupon={m.receiver_coupon_no}
//                     isRoot
//                     subCount={directMembers.length}
//                     children={directMembers.map(d => ({
//                       name: d.receiver_name,
//                       coupon: d.receiver_coupon_no,
//                       mobile: d.receiver_mobile,
//                       isApproved: !!d.is_approved,
//                       subCount: d.their_direct,
//                     }))}
//                   />
//                 </div>
//               </div>
//               <p style={{ fontSize: 12, color: "#64748b", marginTop: 10, textAlign: "center" }}>
//                 Shows your direct referrals (Level 1). Number below each node = their own direct count.
//               </p>
//             </div>
//           )}

//           {/* ══════════ INDIRECT TREE ══════════ */}
//           {subTab === "Indirect Tree" && (
//             <div>
//               <PageHead title="🌐 My Full Network Tree (All 6 Levels)" />
//               {allTeam.length === 0 && directMembers.length === 0 ? (
//                 <div style={{ textAlign: "center", padding: 60, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0" }}>
//                   <div style={{ fontSize: 40, marginBottom: 12 }}>🌐</div>
//                   <div style={{ fontWeight: 700 }}>No team members yet</div>
//                   <div style={{ fontSize: 12, marginTop: 8 }}>Share your referral link to build your network</div>
//                 </div>
//               ) : (
//                 <>
//                   <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
//                     {[1, 2, 3, 4, 5, 6].map(lvl => {
//                       const count = allTeam.filter(t => Number(t.lvl) === lvl).length;
//                       return (
//                         <div key={lvl} style={{ background: PIE_COLORS[lvl - 1], color: "#fff", borderRadius: 8, padding: "10px 14px", minWidth: 90, textAlign: "center", flex: 1 }}>
//                           <div style={{ fontSize: 10, opacity: .8 }}>Level {lvl}</div>
//                           <div style={{ fontSize: 22, fontWeight: 800 }}>{count}</div>
//                           <div style={{ fontSize: 10, opacity: .8 }}>members</div>
//                         </div>
//                       );
//                     })}
//                   </div>
//                   <div style={{ ...S.card, padding: isMobile ? 8 : 16, maxHeight: isMobile ? 400 : 600, overflowY: "auto" }}>
//                     <ExpandableTreeNode node={buildTree()} depth={0} isRoot />
//                   </div>
//                   <div style={{ display: "flex", gap: 10, marginTop: 10, flexWrap: "wrap" }}>
//                     {PIE_COLORS.map((c, i) => (
//                       <div key={i} style={{ display: "flex", alignItems: "center", gap: 5 }}>
//                         <div style={{ width: 12, height: 12, borderRadius: 3, background: c }} />
//                         <span style={{ fontSize: 11, color: "#64748b" }}>Level {i + 1}</span>
//                       </div>
//                     ))}
//                     <div style={{ fontSize: 11, color: "#94a3b8", marginLeft: "auto" }}>Click ▶ to expand • Shows up to 6 levels</div>
//                   </div>
//                 </>
//               )}
//             </div>
//           )}

//           {/* ══════════ DATE WISE BUSINESS ══════════ */}
//           {subTab === "Date Wise Business" && (
//             <DateWiseBusiness directMembers={directMembers} allTeam={allTeam} />
//           )}

//           {/* ══════════ DIRECT INCOME ══════════ */}
//           {subTab === "Direct Income" && (
//             <div>
//               <PageHead title="💹 Direct Income Summary" />
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["S.No", "Id No", "Member Name", "Trade Income", "Direct Income", "Level Income", "Salary Income", "Total Income"]} />
//                   <tbody>
//                     <tr style={S.trEven}>
//                       <td style={S.td}>1</td>
//                       <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{m.receiver_coupon_no}</td>
//                       <td style={S.td}>{m.receiver_name}</td>
//                       <td style={S.td}>₹0.00</td>
//                       <td style={{ ...S.td, color: "#16a34a", fontWeight: 700 }}>{inr(stats.direct * LEVEL_RATE[1])}</td>
//                       <td style={{ ...S.td, color: "#7c3aed", fontWeight: 700 }}>{inr(totalIncome)}</td>
//                       <td style={S.td}>{inr(data.salary?.amount || 0)}</td>
//                       <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 15 }}>
//                         {inr(stats.direct * LEVEL_RATE[1] + totalIncome + (data.salary?.amount || 0))}
//                       </td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ LEVEL INCOME ══════════ */}
//           {subTab === "Level Income" && (
//             <div>
//               <PageHead title="📈 Level Income — Detailed" />
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Date", "Level", "Member Name", "Coupon", "Mobile", "Amount"]} />
//                   <tbody>
//                     {levelPayout.map((p, i) => (
//                       <tr key={i} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(p.created_at)}</td>
//                         <td style={S.td}>
//                           <span style={{ ...S.pill, background: PIE_COLORS[(p.level - 1) % 6] + "22", color: PIE_COLORS[(p.level - 1) % 6], border: `1px solid ${PIE_COLORS[(p.level - 1) % 6]}` }}>
//                             L{p.level}
//                           </span>
//                         </td>
//                         <td style={{ ...S.td, fontWeight: 600 }}>{p.from_name || "—"}</td>
//                         <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700 }}>{p.from_coupon || p.from_token}</td>
//                         <td style={{ ...S.td, fontSize: 11, color: "#64748b" }}>{p.from_mobile || "—"}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(p.amount)}</td>
//                       </tr>
//                     ))}
//                     {levelPayout.length === 0 && (
//                       <tr><td colSpan={7} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 32 }}>No income credited yet</td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ TOTAL PAYOUT BY LEVEL ══════════ */}
//           {subTab === "Total Payout by Level" && (
//             <div>
//               <PageHead title="💸 Total Payout — Level-wise Breakdown" />
//               <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
//                 {[1, 2, 3, 4, 5, 6].map(l => {
//                   const found = totalPayoutByLevel.find(li => li.level === l);
//                   const earned = Number(found?.total || 0);
//                   return (
//                     <div key={l} style={{ background: "#fff", border: `2px solid ${PIE_COLORS[l - 1]}`, borderRadius: 10, padding: "14px 18px", minWidth: 90, flex: "1 1 90px", textAlign: "center" }}>
//                       <div style={{ fontSize: 11, color: "#64748b" }}>Level {l}</div>
//                       <div style={{ fontSize: 11, color: "#94a3b8" }}>₹{LEVEL_RATE[l]}/join</div>
//                       <div style={{ fontSize: 20, fontWeight: 800, color: PIE_COLORS[l - 1], margin: "6px 0" }}>{inr(earned)}</div>
//                       <div style={{ fontSize: 11, color: "#64748b" }}>{found?.count || 0} payouts</div>
//                     </div>
//                   );
//                 })}
//               </div>
//               <SectionTitle>Payout Summary Table</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["Level", "Rate/Join ₹", "Members Paid", "Total Amount Received", "% of Total Earnings"]} />
//                   <tbody>
//                     {[1, 2, 3, 4, 5, 6].map((level, i) => {
//                       const found = totalPayoutByLevel.find(l => l.level === level);
//                       const earned = Number(found?.total || 0);
//                       const pct = totalIncome > 0 ? ((earned / totalIncome) * 100).toFixed(1) : "0";
//                       return (
//                         <tr key={level} style={i % 2 === 0 ? S.trEven : {}}>
//                           <td style={S.td}><b>Level {level}</b> {level === 1 ? "🔴 Direct" : level <= 3 ? "🟡 Close" : "🟢 Deep"}</td>
//                           <td style={S.td}>₹{LEVEL_RATE[level]}</td>
//                           <td style={S.td}>{found?.count || 0}</td>
//                           <td style={{ ...S.td, fontWeight: 700, color: earned > 0 ? "#16a34a" : "#94a3b8", fontSize: 14 }}>
//                             {earned > 0 ? inr(earned) : "₹0.00"}
//                           </td>
//                           <td style={S.td}>
//                             <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                               <div style={{ flex: 1, height: 8, background: "#f1f5f9", borderRadius: 99, overflow: "hidden" }}>
//                                 <div style={{ height: "100%", width: `${Math.min(Number(pct), 100)}%`, background: PIE_COLORS[i], borderRadius: 99, transition: "width .5s" }} />
//                               </div>
//                               <span style={{ fontSize: 11, color: "#64748b", minWidth: 32 }}>{pct}%</span>
//                             </div>
//                           </td>
//                         </tr>
//                       );
//                     })}
//                     <tr style={{ background: "#f0fdf4" }}>
//                       <td style={{ ...S.td, fontWeight: 800 }} colSpan={2}>GRAND TOTAL</td>
//                       <td style={{ ...S.td, fontWeight: 700 }}>{totalPayoutByLevel.reduce((s, l) => s + l.count, 0)}</td>
//                       <td style={{ ...S.td, fontWeight: 800, color: "#15803d", fontSize: 16 }}>{inr(totalIncome)}</td>
//                       <td style={S.td}><span style={S.greenBadge}>100%</span></td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//               <SectionTitle>📋 Detailed — Who Joined & Earned Me Commission</SectionTitle>
//               <p style={{ fontSize: 12, color: "#64748b", marginBottom: 10 }}>
//                 Each row = one join event. Level 1 = your direct referral. Level 2–6 = their downline under your network.
//               </p>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Date", "Level", "Member Name", "Coupon", "Mobile", "Commission", "Note"]} />
//                   <tbody>
//                     {levelPayout.map((p, i) => (
//                       <tr key={i} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmt(p.created_at)}</td>
//                         <td style={S.td}>
//                           <span style={{ ...S.pill, background: PIE_COLORS[(p.level - 1) % 6] + "22", color: PIE_COLORS[(p.level - 1) % 6] }}>L{p.level}</span>
//                         </td>
//                         <td style={{ ...S.td, fontWeight: 600 }}>{p.from_name || "—"}</td>
//                         <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 600 }}>{p.from_coupon || p.from_token}</td>
//                         <td style={{ ...S.td, fontSize: 11, color: "#64748b" }}>{p.from_mobile || "—"}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(p.amount)}</td>
//                         <td style={{ ...S.td, fontSize: 11, color: "#64748b" }}>
//                           {p.level === 1 ? "Your direct referral joined" : `Level ${p.level} downline joined`}
//                         </td>
//                       </tr>
//                     ))}
//                     {levelPayout.length === 0 && (
//                       <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 32 }}>
//                         No commission history yet. Start referring!
//                       </td></tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ SALARY ══════════ */}
//           {subTab === "Salary" && (
//             <div>
//               <PageHead title="💰 Salary Details" />
//               <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
//                 <div style={{ ...S.card, padding: 20, textAlign: "center", minWidth: "min(180px, 45%)" }}>
//                   <div style={{ fontSize: 11, color: "#64748b" }}>Current Rank</div>
//                   <div style={{ fontSize: 22, fontWeight: 800, color: "#1e3a8a", margin: "8px 0" }}>{m.rank?.toUpperCase()}</div>
//                 </div>
//                 <div style={{ ...S.card, padding: 20, textAlign: "center", minWidth: "min(180px, 45%)" }}>
//                   <div style={{ fontSize: 11, color: "#64748b" }}>This Month's Salary</div>
//                   <div style={{ fontSize: 22, fontWeight: 800, color: "#16a34a", margin: "8px 0" }}>{inr(data.salary?.amount || 0)}</div>
//                   <span style={data.salary?.is_approved ? S.greenBadge : S.yellowBadge}>
//                     {data.salary?.is_approved ? "Paid ✅" : data.salary ? "Pending" : "Not Generated"}
//                   </span>
//                 </div>
//               </div>
//               <div style={{ ...S.card, padding: 16 }}>
//                 <div style={S.cardHead}>Rank Salary Chart</div>
//                 <div style={{ padding: 16 }}>
//                   {[["Member", 0], ["Silver", 1000], ["Gold", 3000], ["Platinum", 7000], ["Diamond", 15000]].map(([rank, amt]) => (
//                     <div key={rank} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #f1f5f9", alignItems: "center" }}>
//                       <span style={{ fontWeight: 600 }}>
//                         {rank.toLowerCase() === m.rank?.toLowerCase() ? `✅ ${rank} ← You` : rank}
//                       </span>
//                       <span style={{ fontWeight: 700, color: amt > 0 ? "#16a34a" : "#94a3b8" }}>
//                         {amt > 0 ? inr(amt) + "/month" : "No salary"}
//                       </span>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ WALLET REPORT ══════════ */}
//           {subTab === "Wallet Report" && (
//             <div>
//               <PageHead title="📊 Wallet Report" />
//               <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
//                 {[["Earning Wallet", m.wallet_balance, "#1e3a8a"], ["Salary Wallet", data.salary?.amount || 0, "#065f46"], ["Total Withdrawn", recentTxn.filter(t => t.type === "debit").reduce((s, t) => s + Number(t.amount), 0), "#7f1d1d"]].map(([label, val, bg]) => (
//                   <div key={label} style={{ ...S.kpiCard, background: bg, flex: 1, minWidth: 150 }}>
//                     <div style={{ fontSize: 11, opacity: .8 }}>{label}</div>
//                     <div style={{ fontSize: 20, fontWeight: 800 }}>{inr(val)}</div>
//                   </div>
//                 ))}
//               </div>
//               <SectionTitle>Recent Transactions</SectionTitle>
//               <div style={S.tableWrap}>
//                 <table style={S.table}>
//                   <THead cols={["#", "Date", "Type", "Description", "Amount"]} />
//                   <tbody>
//                     {recentTxn.map((t, i) => (
//                       <tr key={t.id} style={i % 2 === 0 ? S.trEven : {}}>
//                         <td style={S.td}>{i + 1}</td>
//                         <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(t.created_at)}</td>
//                         <td style={S.td}><span style={t.type === "credit" ? S.greenBadge : S.redBadge}>{t.type}</span></td>
//                         <td style={S.td}>{t.description}</td>
//                         <td style={{ ...S.td, fontWeight: 700, color: t.type === "credit" ? "#16a34a" : "#dc2626" }}>
//                           {t.type === "credit" ? "+" : "−"}{inr(t.amount)}
//                         </td>
//                       </tr>
//                     ))}
//                     {recentTxn.length === 0 && <tr><td colSpan={5} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No transactions yet</td></tr>}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}

//           {/* ══════════ WITHDRAWAL ══════════ */}
//           {subTab === "Withdrawal" && (
//             <div>
//               <PageHead title="💸 Request Withdrawal" />
//               <div style={{ ...S.card, maxWidth: "min(480px, 100%)" }}>
//                 <div style={S.cardHead}>Withdrawal Request</div>
//                 <div style={{ padding: "16px" }}>
//                   <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 8, padding: 14, marginBottom: 16, textAlign: "center" }}>
//                     <div style={{ fontSize: 11, color: "#15803d" }}>Available Balance</div>
//                     <div style={{ fontSize: 26, fontWeight: 900, color: "#15803d" }}>{inr(m.wallet_balance)}</div>
//                   </div>
//                   <div style={{ marginBottom: 12 }}>
//                     <label style={S.label}>Amount (₹) *</label>
//                     <input style={S.input} type="number" value={withdrawForm.amount}
//                       onChange={e => setWithdrawForm({ ...withdrawForm, amount: e.target.value })} />
//                   </div>
//                   <div style={{ marginBottom: 16 }}>
//                     <label style={S.label}>Method *</label>
//                     <select style={S.input} value={withdrawForm.method}
//                       onChange={e => setWithdrawForm({ ...withdrawForm, method: e.target.value })}>
//                       <option value="upi">UPI</option>
//                       <option value="bank">Bank Transfer</option>
//                     </select>
//                   </div>
//                   <button style={{ ...S.btn, background: "#1e3a8a", width: "100%", padding: 12, fontSize: 14 }}
//                     onClick={submitWithdraw}>Submit Withdrawal Request</button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ WITHDRAWAL DETAIL — two-column: form left, preview right ══════════ */}
//           {subTab === "Withdrawal Detail" && (
//             <WithdrawalDetailPanel token={token} bankForm={bankForm} setBankForm={setBankForm} saveBank={saveBank} />
//           )}

//           {/* ══════════ RAISE TICKET ══════════ */}
//           {subTab === "Raise Ticket" && (
//             <div>
//               <PageHead title="🎫 Raise Support Ticket" />
//               <div style={{ ...S.card, maxWidth: "min(560px, 100%)" }}>
//                 <div style={S.cardHead}>Submit a Ticket</div>
//                 <div style={{ padding: "16px" }}>
//                   {[["Username", m.receiver_coupon_no, true], ["Name", m.receiver_name, true], ["Mobile No", m.receiver_mobile || "", true]].map(([label, val, ro]) => (
//                     <div key={label} style={{ marginBottom: 12 }}>
//                       <label style={S.label}>{label} *</label>
//                       <input style={{ ...S.input, background: ro ? "#f8fafc" : "#fff" }} value={val} readOnly={ro} />
//                     </div>
//                   ))}
//                   <div style={{ marginBottom: 12 }}>
//                     <label style={S.label}>Nature of Grievance *</label>
//                     <select style={S.input} value={ticketForm.nature}
//                       onChange={e => setTicketForm({ ...ticketForm, nature: e.target.value })}>
//                       <option>Support</option><option>Technical</option><option>Payment</option><option>Other</option>
//                     </select>
//                   </div>
//                   <div style={{ marginBottom: 16 }}>
//                     <label style={S.label}>Description *</label>
//                     <textarea style={{ ...S.input, height: 90, resize: "vertical" }}
//                       value={ticketForm.description}
//                       onChange={e => setTicketForm({ ...ticketForm, description: e.target.value })}
//                       placeholder="Describe your issue in detail..." />
//                   </div>
//                   <button style={{ ...S.btn, background: "#1e3a8a", width: "100%", padding: 12 }}
//                     onClick={() => {
//                       if (!ticketForm.description) { toast.error("Please enter description"); return; }
//                       const msg = `🛑 Support Ticket - ${COMPANY}\n\n👤 Name: ${m.receiver_name}\n🆔 ID: ${m.receiver_coupon_no}\n📱 Mobile: ${m.receiver_mobile || "N/A"}\n📌 Nature: ${ticketForm.nature}\n\n📝 Issue:\n${ticketForm.description}\n\n📅 Date: ${new Date().toLocaleString("en-IN")}`;
//                       window.open("https://wa.me/918275547499?text=" + encodeURIComponent(msg), "_blank");
//                       toast.success("Redirecting to WhatsApp Support...");
//                       setTicketForm({ nature: "Support", description: "" });
//                     }}>
//                     Submit Ticket via WhatsApp 📱
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ MY PROFILE ══════════ */}
//           {subTab === "My Profile" && (
//             <div>
//               <PageHead title="👤 My Profile" />
//               <div style={{ ...S.card, maxWidth: "min(600px, 100%)" }}>
//                 <div style={S.cardHead}>Profile Details</div>
//                 <div style={{ padding: 24 }}>
//                   {[
//                     ["Full Name", m.receiver_name],
//                     ["User ID / Coupon", m.receiver_coupon_no],
//                     ["Mobile Number", m.receiver_mobile],
//                     ["Joining Date", fmt(m.created_at)],
//                     ["Current Rank", m.rank?.toUpperCase()],
//                     ["Wallet Balance", inr(m.wallet_balance)],
//                     ["Direct Members", stats.direct],
//                     ["Total Team", stats.total_team],
//                   ].map(([label, value]) => (
//                     <div key={label} style={{ display: "flex", justifyContent: "space-between", padding: "12px 0", borderBottom: "1px solid #f1f5f9" }}>
//                       <span style={{ color: "#64748b" }}>{label}</span>
//                       <span style={{ fontWeight: 700 }}>{value || "—"}</span>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ WELCOME LETTER ══════════ */}
//           {subTab === "Welcome Letter" && (
//             <div>
//               <PageHead title="📄 Welcome Letter" />
//               <div style={{ ...S.card, maxWidth: "min(600px, 100%)" }}>
//                 <div style={S.cardHead}>Official Welcome Letter — Meruram</div>
//                 <div style={{ padding: 24 }}>
//                   <p style={{ fontWeight: 700, marginBottom: 4 }}>Welcome to {COMPANY}!</p>
//                   <p style={{ fontStyle: "italic", color: "#64748b", marginBottom: 16 }}>Dear {m.receiver_name},</p>
//                   <p style={{ fontSize: 13, lineHeight: 1.8, color: "#475569", marginBottom: 20 }}>
//                     We are delighted to have you as a member of our growing Meruram family. Participate, refer friends, and earn exciting rewards at every level.
//                     <br /><br />
//                     Visit us at: <a href={COMPANY_URL} style={{ color: "#ea580c", fontWeight: 600 }}>{COMPANY_URL}</a>
//                   </p>
//                   <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden" }}>
//                     {[["Member Name", m.receiver_name], ["Member ID / Coupon", m.receiver_coupon_no],
//                       ["Joining Date", fmt(m.created_at)], ["Current Rank", m.rank?.toUpperCase()],
//                       ["Wallet Balance", inr(m.wallet_balance)]].map(([k, v], idx) => (
//                       <div key={k} style={{ display: "flex", padding: "11px 16px", borderBottom: "1px solid #e2e8f0", background: idx % 2 === 0 ? "#fff" : "#f8fafc" }}>
//                         <div style={{ width: 180, color: "#64748b", fontSize: 13 }}>{k}</div>
//                         <div style={{ fontWeight: 700, fontSize: 13 }}>: {v}</div>
//                       </div>
//                     ))}
//                   </div>
//                   <div style={{ marginTop: 20, padding: 16, background: "#fefce8", border: "1px solid #fde68a", borderRadius: 8, fontSize: 12, color: "#854d0e" }}>
//                     <strong>Note:</strong> Keep your login credentials safe. Contact support if you need assistance.
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ══════════ CHANGE PASSWORD ══════════ */}
//           {subTab === "Change Password" && (
//             <ChangePasswordPanel memberToken={m.token_number} couponNo={m.receiver_coupon_no} />
//           )}

//           {/* Fallback */}
//           {tab !== "dashboard" && !subTab && (
//             <div style={{ padding: 40, textAlign: "center", color: "#94a3b8" }}>
//               <div style={{ fontSize: 32, marginBottom: 10 }}>👆</div>
//               Tap the menu (☰) to navigate
//             </div>
//           )}
//         </main>
//       </div>

//       {/* ── MOBILE BOTTOM NAV ── */}
//       {isMobile && (
//         <nav style={{
//           position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 500,
//           background: "#1e3a8a", display: "flex", borderTop: "2px solid #1d4ed8",
//           boxShadow: "0 -2px 12px rgba(0,0,0,.3)",
//         }}>
//           {[
//             { icon: "📊", label: "Home", action: () => goTo("dashboard") },
//             { icon: "👥", label: "Team", action: () => { setOpenNav(p => ({ ...p, myteam: true })); setSidebarOpen(true); } },
//             { icon: "💹", label: "Income", action: () => { setOpenNav(p => ({ ...p, incentive: true })); setSidebarOpen(true); } },
//             { icon: "💰", label: "Wallet", action: () => goTo("wallet", "Wallet Report") },
//             { icon: "☰", label: "Menu", action: () => setSidebarOpen(o => !o) },
//           ].map(item => (
//             <button key={item.label} onClick={item.action}
//               style={{ flex: 1, background: "none", border: "none", color: "#bfdbfe",
//                 padding: "10px 4px 8px", cursor: "pointer", textAlign: "center",
//                 fontSize: 10, display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
//               <span style={{ fontSize: 20 }}>{item.icon}</span>
//               <span>{item.label}</span>
//             </button>
//           ))}
//         </nav>
//       )}
//       {isMobile && <div style={{ height: 64 }} />}
//     </div>
//   );
// }

// /* ══════════════════════════════════════════════════════
//    WITHDRAWAL DETAIL PANEL
//    Form on left, live bank card preview on right
// ══════════════════════════════════════════════════════ */
// function WithdrawalDetailPanel({ token, bankForm, setBankForm, saveBank }) {
//   const [saved, setSaved] = useState(null);
//   const [saving, setSaving] = useState(false);

//   /* Load existing bank details on mount */
//   useEffect(() => {
//     api.get(`/wallet/bank/${token}`)
//       .then(res => {
//         if (res.data) {
//           const d = res.data;
//           setBankForm({
//             bank_name: d.bank_name || "",
//             account_number: d.account_number || "",
//             ifsc: d.ifsc || "",
//             upi_id: d.upi_id || "",
//           });
//           setSaved(d);
//         }
//       })
//       .catch(() => {/* no saved details yet — that's fine */});
//   }, []);

//   const handleSave = async () => {
//     setSaving(true);
//     try {
//       await saveBank();
//       setSaved({ ...bankForm });
//     } catch {}
//     setSaving(false);
//   };

//   const fields = [
//     ["Bank Name", "bank_name", "🏦", "e.g. State Bank of India"],
//     ["Account Number", "account_number", "🔢", "e.g. 1234567890"],
//     ["IFSC Code", "ifsc", "🏷️", "e.g. SBIN0001234"],
//     ["UPI ID", "upi_id", "📱", "e.g. name@upi"],
//   ];

//   const hasData = saved && (saved.bank_name || saved.account_number || saved.ifsc || saved.upi_id);

//   return (
//     <div>
//       <PageHead title="🏦 Bank / UPI Details" />
//       <div style={{ display: "flex", gap: 16, flexWrap: "wrap", alignItems: "flex-start" }}>

//         {/* ── LEFT: Form ── */}
//         <div style={{ ...S.card, flex: "1 1 280px", maxWidth: 460 }}>
//           <div style={S.cardHead}>Add / Update Payment Details</div>
//           <div style={{ padding: 20 }}>
//             <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: 12, marginBottom: 16, fontSize: 12, color: "#1e40af" }}>
//               💡 These details are used when you request a withdrawal. Keep them accurate.
//             </div>
//             {fields.map(([label, key, icon, placeholder]) => (
//               <div key={key} style={{ marginBottom: 14 }}>
//                 <label style={S.label}>{icon} {label}</label>
//                 <input
//                   style={S.input}
//                   placeholder={placeholder}
//                   value={bankForm[key]}
//                   onChange={e => setBankForm({ ...bankForm, [key]: e.target.value })}
//                 />
//               </div>
//             ))}
//             <button
//               style={{ ...S.btn, background: saving ? "#94a3b8" : "#1e3a8a", width: "100%", padding: 12, fontSize: 14, justifyContent: "center" }}
//               onClick={handleSave}
//               disabled={saving}
//             >
//               {saving ? "Saving..." : "💾 Save Payment Details"}
//             </button>
//           </div>
//         </div>

//         {/* ── RIGHT: Preview ── */}
//         <div style={{ flex: "1 1 260px", maxWidth: 400 }}>
//           {hasData ? (
//             <>
//               {/* Bank debit-card style */}
//               <div style={{
//                 background: "linear-gradient(135deg, #1e3a8a 0%, #1d4ed8 55%, #3b82f6 100%)",
//                 borderRadius: 18, padding: "24px 24px 20px", color: "#fff",
//                 boxShadow: "0 10px 36px rgba(30,58,138,.38)",
//                 position: "relative", overflow: "hidden", marginBottom: 14,
//               }}>
//                 {/* Decorative circles */}
//                 <div style={{ position: "absolute", top: -28, right: -28, width: 110, height: 110, borderRadius: "50%", background: "rgba(255,255,255,.08)" }} />
//                 <div style={{ position: "absolute", bottom: -36, left: -16, width: 140, height: 140, borderRadius: "50%", background: "rgba(255,255,255,.05)" }} />
//                 <div style={{ position: "absolute", top: 20, right: 20, width: 50, height: 50, borderRadius: "50%", background: "rgba(255,255,255,.12)" }} />

//                 {/* Top row */}
//                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 22 }}>
//                   <div>
//                     <div style={{ fontSize: 9, opacity: .65, letterSpacing: 2.5, marginBottom: 4 }}>BANK NAME</div>
//                     <div style={{ fontSize: 16, fontWeight: 800, letterSpacing: .4 }}>{saved.bank_name || "—"}</div>
//                   </div>
//                   <div style={{ fontSize: 32, lineHeight: 1 }}>🏦</div>
//                 </div>

//                 {/* Account number */}
//                 <div style={{ marginBottom: 18 }}>
//                   <div style={{ fontSize: 9, opacity: .65, letterSpacing: 2.5, marginBottom: 4 }}>ACCOUNT NUMBER</div>
//                   <div style={{ fontSize: 18, fontWeight: 700, letterSpacing: 4, fontFamily: "monospace" }}>
//                     {saved.account_number
//                       ? saved.account_number.replace(/(.{4})/g, "$1 ").trim()
//                       : "—"}
//                   </div>
//                 </div>

//                 {/* Bottom row */}
//                 <div style={{ display: "flex", gap: 28 }}>
//                   <div>
//                     <div style={{ fontSize: 9, opacity: .65, letterSpacing: 2.5, marginBottom: 3 }}>IFSC CODE</div>
//                     <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: .5 }}>{saved.ifsc || "—"}</div>
//                   </div>
//                   <div>
//                     <div style={{ fontSize: 9, opacity: .65, letterSpacing: 2.5, marginBottom: 3 }}>ACCOUNT TYPE</div>
//                     <div style={{ fontSize: 13, fontWeight: 700 }}>SAVINGS</div>
//                   </div>
//                 </div>
//               </div>

//               {/* UPI card */}
//               {saved.upi_id && (
//                 <div style={{
//                   background: "linear-gradient(135deg, #064e3b 0%, #065f46 100%)",
//                   borderRadius: 14, padding: "16px 20px", color: "#fff",
//                   boxShadow: "0 6px 20px rgba(6,79,59,.32)",
//                   display: "flex", alignItems: "center", gap: 14,
//                   marginBottom: 14,
//                 }}>
//                   <div style={{ fontSize: 34, lineHeight: 1 }}>📱</div>
//                   <div>
//                     <div style={{ fontSize: 9, opacity: .7, letterSpacing: 2.5, marginBottom: 4 }}>UPI ID</div>
//                     <div style={{ fontSize: 15, fontWeight: 800, letterSpacing: .3 }}>{saved.upi_id}</div>
//                     <div style={{ fontSize: 11, opacity: .7, marginTop: 3 }}>Instant transfer ready</div>
//                   </div>
//                 </div>
//               )}

//               {/* Saved status badge */}
//               <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 10 }}>
//                 <span style={{ fontSize: 20 }}>✅</span>
//                 <div>
//                   <div style={{ fontSize: 13, fontWeight: 700, color: "#15803d" }}>Payment Details Saved</div>
//                   <div style={{ fontSize: 11, color: "#16a34a" }}>Withdrawals will be sent to these details</div>
//                 </div>
//               </div>
//             </>
//           ) : (
//             /* Placeholder when nothing saved */
//             <div style={{
//               border: "2px dashed #cbd5e1", borderRadius: 16, padding: "40px 28px",
//               textAlign: "center", color: "#94a3b8", background: "#f8fafc",
//               display: "flex", flexDirection: "column", alignItems: "center", gap: 10,
//             }}>
//               <div style={{ fontSize: 48 }}>🏦</div>
//               <div style={{ fontWeight: 700, fontSize: 14, color: "#64748b" }}>No Details Added Yet</div>
//               <div style={{ fontSize: 12, lineHeight: 1.6 }}>
//                 Fill in the form and tap<br />
//                 <strong style={{ color: "#1e3a8a" }}>Save Payment Details</strong><br />
//                 to see your bank card preview here
//               </div>
//             </div>
//           )}
//         </div>

//       </div>
//     </div>
//   );
// }

// /* ══════════════════════════════════════════════════════
//    CHANGE PASSWORD — isolated component with own state
// ══════════════════════════════════════════════════════ */
// function ChangePasswordPanel({ memberToken, couponNo }) {
//   const [current, setCurrent] = useState("");
//   const [newPwd, setNewPwd]   = useState("");
//   const [confirm, setConfirm] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleSubmit = async () => {
//     if (!newPwd)           { toast.error("New password is required"); return; }
//     if (newPwd.length < 6) { toast.error("Password must be at least 6 characters"); return; }
//     if (newPwd !== confirm) { toast.error("Passwords do not match"); return; }
//     setLoading(true);
//     try {
//       await api.post("/mlm/member-change-password", {
//         token_number: memberToken,
//         old_password: current || undefined,
//         new_password: newPwd,
//       });
//       toast.success("✅ Password changed successfully!");
//       setCurrent(""); setNewPwd(""); setConfirm("");
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed. Please try again.");
//     }
//     setLoading(false);
//   };

//   return (
//     <div>
//       <PageHead title="🔐 Change Password" />
//       <div style={{ ...S.card, maxWidth: "min(500px, 100%)" }}>
//         <div style={S.cardHead}>Update Your Password</div>
//         <div style={{ padding: 24 }}>
//           <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: 12, marginBottom: 16, fontSize: 12, color: "#1e40af" }}>
//             💡 <strong>First time?</strong> Leave "Current Password" blank to set your password for the first time.
//           </div>
//           <div style={{ marginBottom: 12 }}>
//             <label style={S.label}>User ID (Coupon No)</label>
//             <input style={{ ...S.input, background: "#f8fafc", color: "#64748b" }} value={couponNo} readOnly />
//           </div>
//           <div style={{ marginBottom: 12 }}>
//             <label style={S.label}>Current Password <span style={{ color: "#94a3b8", fontSize: 11 }}>(leave blank if setting for first time)</span></label>
//             <input type="password" style={S.input} placeholder="Enter current password"
//               value={current} onChange={e => setCurrent(e.target.value)} />
//           </div>
//           <div style={{ marginBottom: 12 }}>
//             <label style={S.label}>New Password *</label>
//             <input type="password" style={S.input} placeholder="Minimum 6 characters"
//               value={newPwd} onChange={e => setNewPwd(e.target.value)} />
//           </div>
//           <div style={{ marginBottom: 8 }}>
//             <label style={S.label}>Confirm New Password *</label>
//             <input type="password" style={S.input} placeholder="Re-enter new password"
//               value={confirm} onChange={e => setConfirm(e.target.value)} />
//           </div>
//           {confirm.length > 0 && (
//             <div style={{ marginBottom: 16, fontSize: 12, fontWeight: 700, color: newPwd === confirm ? "#16a34a" : "#dc2626" }}>
//               {newPwd === confirm ? "✅ Passwords match" : "❌ Passwords do not match"}
//             </div>
//           )}
//           <button
//             style={{ ...S.btn, background: loading ? "#94a3b8" : "#1e3a8a", width: "100%", padding: 12, fontSize: 14 }}
//             onClick={handleSubmit} disabled={loading}>
//             {loading ? "Updating..." : "🔐 Update Password"}
//           </button>
//           <p style={{ fontSize: 11, color: "#94a3b8", marginTop: 12, textAlign: "center" }}>
//             Need help? <a href="https://wa.me/918275547499" target="_blank" rel="noreferrer"
//               style={{ color: "#25D366", fontWeight: 600 }}>Contact WhatsApp Support</a>
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ══════════════════════════════════════════════════════
//    DATE WISE BUSINESS
// ══════════════════════════════════════════════════════ */
// function DateWiseBusiness({ directMembers, allTeam }) {
//   const [from, setFrom] = useState(() => new Date(Date.now() - 7 * 86400000).toISOString().slice(0, 10));
//   const [to, setTo]     = useState(() => new Date().toISOString().slice(0, 10));

//   const allMembers = [
//     ...directMembers.map(d => ({ ...d, lvl: 1 })),
//     ...allTeam.filter(t => Number(t.lvl) > 1),
//   ];

//   const filtered = allMembers.filter(mem => {
//     const d = mem.created_at?.slice(0, 10);
//     return d && d >= from && d <= to;
//   });

//   const grouped = {};
//   filtered.forEach(mem => {
//     const d = mem.created_at.slice(0, 10);
//     if (!grouped[d]) grouped[d] = { date: d, count: 0, levels: {} };
//     grouped[d].count++;
//     const lvl = Number(mem.lvl);
//     grouped[d].levels[lvl] = (grouped[d].levels[lvl] || 0) + 1;
//   });
//   const rows = Object.values(grouped).sort((a, b) => b.date.localeCompare(a.date));
//   const totalJoins = rows.reduce((s, r) => s + r.count, 0);

//   return (
//     <div>
//       <PageHead title="📅 Date Wise Business Report" />
//       <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap", alignItems: "flex-end" }}>
//         <div>
//           <label style={S.label}>From Date</label>
//           <input type="date" style={{ ...S.input, width: "auto" }} value={from} onChange={e => setFrom(e.target.value)} />
//         </div>
//         <div>
//           <label style={S.label}>To Date</label>
//           <input type="date" style={{ ...S.input, width: "auto" }} value={to} onChange={e => setTo(e.target.value)} />
//         </div>
//       </div>
//       <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
//         {[["Total Joins", totalJoins, "#1e3a8a"], ["Active Days", rows.length, "#065f46"], ["Avg/Day", rows.length ? Math.round(totalJoins / rows.length) : 0, "#7f1d1d"]].map(([label, val, bg]) => (
//           <div key={label} style={{ ...S.kpiCard, background: bg, flex: 1, minWidth: 130 }}>
//             <div style={{ fontSize: 24, fontWeight: 800 }}>{val}</div>
//             <div style={{ fontSize: 11, opacity: .8 }}>{label}</div>
//           </div>
//         ))}
//       </div>
//       <div style={S.tableWrap}>
//         <table style={S.table}>
//           <THead cols={["Date", "Total Joins", "L1", "L2", "L3", "L4", "L5", "L6"]} />
//           <tbody>
//             {rows.map((r, i) => (
//               <tr key={r.date} style={i % 2 === 0 ? S.trEven : {}}>
//                 <td style={{ ...S.td, fontWeight: 700 }}>{fmt(r.date)}</td>
//                 <td style={{ ...S.td, fontWeight: 800, color: "#1d4ed8", fontSize: 15 }}>{r.count}</td>
//                 {[1, 2, 3, 4, 5, 6].map(l => (
//                   <td key={l} style={{ ...S.td, color: r.levels[l] ? PIE_COLORS[l - 1] : "#cbd5e1", fontWeight: r.levels[l] ? 700 : 400 }}>
//                     {r.levels[l] || 0}
//                   </td>
//                 ))}
//               </tr>
//             ))}
//             {rows.length === 0 && (
//               <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 32 }}>
//                 No joins found in selected date range
//               </td></tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// /* ── Sub-components ── */
// function PageHead({ title, children }) {
//   return (
//     <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16, paddingBottom: 12, borderBottom: "2px solid #e2e8f0" }}>
//       <div style={{ width: 4, height: 20, background: "#ea580c", borderRadius: 99 }} />
//       <span style={{ fontWeight: 700, fontSize: 16, color: "#1e293b" }}>{title}</span>
//       {children}
//     </div>
//   );
// }
// function SectionTitle({ children }) {
//   return <div style={{ fontWeight: 700, fontSize: 13, color: "#1e3a8a", margin: "18px 0 10px", borderLeft: "4px solid #ea580c", paddingLeft: 10 }}>{children}</div>;
// }
// function THead({ cols }) {
//   return (
//     <thead>
//       <tr style={{ background: "#1e3a8a", color: "#fff" }}>
//         {cols.map(c => <th key={c} style={{ padding: "10px 12px", textAlign: "left", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}>{c}</th>)}
//       </tr>
//     </thead>
//   );
// }

// /* ── Direct Tree: box layout ── */
// function TreeBoxNode({ name, coupon, isRoot, isApproved, subCount, children = [] }) {
//   return (
//     <div style={{ textAlign: "center", margin: "0 6px" }}>
//       <div style={{
//         padding: "8px 14px",
//         background: isRoot ? "linear-gradient(135deg,#ea580c,#f97316)" : "#1e3a8a",
//         color: "#fff", borderRadius: 8, fontSize: 12, fontWeight: 700,
//         display: "inline-block", boxShadow: "0 2px 8px rgba(0,0,0,.2)", minWidth: 100,
//         border: isRoot ? "2px solid #fff" : "none",
//       }}>
//         <div>{name}</div>
//         {coupon && <div style={{ fontSize: 10, opacity: .8, marginTop: 2 }}>{coupon}</div>}
//         {subCount !== undefined && (
//           <div style={{ fontSize: 10, marginTop: 3, background: "rgba(255,255,255,.2)", borderRadius: 4, padding: "1px 4px" }}>
//             {subCount} direct
//           </div>
//         )}
//         {isApproved !== undefined && (
//           <div style={{ fontSize: 10, marginTop: 2, color: isApproved ? "#4ade80" : "#fbbf24" }}>
//             {isApproved ? "Active ✅" : "Pending ⏳"}
//           </div>
//         )}
//       </div>
//       {children.length > 0 && (
//         <>
//           <div style={{ width: 2, height: 20, background: "#94a3b8", margin: "0 auto" }} />
//           <div style={{ display: "flex", justifyContent: "center", position: "relative" }}>
//             {children.length > 1 && (
//               <div style={{ position: "absolute", top: 0, left: "10%", right: "10%", height: 2, background: "#94a3b8" }} />
//             )}
//             {children.map((child, i) => (
//               <div key={i}>
//                 <div style={{ width: 2, height: 16, background: "#94a3b8", margin: "0 auto" }} />
//                 <TreeBoxNode {...child} />
//               </div>
//             ))}
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// /* ── Expandable tree node for Indirect Tree ── */
// function ExpandableTreeNode({ node, depth = 0, isRoot = false }) {
//   const [expanded, setExpanded] = useState(depth < 2);
//   const DEPTH_COLORS = ["#1e3a8a", "#1d4ed8", "#3b82f6", "#60a5fa", "#93c5fd", "#bfdbfe"];
//   const textColors =  ["#fff",     "#fff",     "#fff",     "#fff",    "#1e3a8a", "#1e3a8a"];
//   if (!node) return null;
//   const hasChildren = node.children && node.children.length > 0;
//   return (
//     <div style={{ marginLeft: Math.min(depth * 16, 80), marginBottom: 3 }}>
//       <div onClick={() => hasChildren && setExpanded(e => !e)}
//         style={{
//           display: "flex", alignItems: "center", gap: 8, padding: "7px 12px",
//           background: DEPTH_COLORS[Math.min(depth, 5)],
//           color: textColors[Math.min(depth, 5)],
//           borderRadius: 7, cursor: hasChildren ? "pointer" : "default",
//           border: isRoot ? "2px solid #f97316" : "1px solid rgba(0,0,0,.08)",
//           userSelect: "none",
//         }}>
//         <span style={{ fontSize: 11, minWidth: 14, opacity: .8 }}>
//           {hasChildren ? (expanded ? "▼" : "▶") : "●"}
//         </span>
//         <span style={{ fontWeight: 700, fontSize: 12 }}>{node.receiver_coupon_no || node.token_number}</span>
//         <span style={{ fontSize: 12 }}>{node.receiver_name}</span>
//         {node.receiver_mobile && window.innerWidth >= 768 && (
//           <span style={{ fontSize: 11, opacity: .75, marginLeft: 4 }}>{node.receiver_mobile}</span>
//         )}
//         {isRoot && <span style={{ fontSize: 10, background: "#f97316", borderRadius: 99, padding: "1px 7px", marginLeft: 4 }}>YOU</span>}
//         {hasChildren && (
//           <span style={{ marginLeft: "auto", background: "rgba(255,255,255,.25)", borderRadius: 99, padding: "1px 8px", fontSize: 11 }}>
//             {node.children.length} ▸
//           </span>
//         )}
//         <span style={{ background: node.is_approved ? "#16a34a" : "#f59e0b", borderRadius: 99, padding: "1px 6px", fontSize: 10, color: "#fff", marginLeft: hasChildren ? 0 : "auto" }}>
//           {node.is_approved ? "✓" : "⏳"}
//         </span>
//       </div>
//       {expanded && hasChildren && (
//         <div style={{ borderLeft: "2px solid #bfdbfe", marginLeft: 16, paddingLeft: 6, marginTop: 3 }}>
//           {node.children.map(child => (
//             <ExpandableTreeNode key={child.token_number} node={child} depth={depth + 1} />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// /* ── Styles ── */
// const S = {
//   shell: { display: "flex", flexDirection: "column", minHeight: "100vh", fontFamily: "'Segoe UI', system-ui, sans-serif", fontSize: 13, background: "#f1f5f9" },
//   topbar: { background: "linear-gradient(90deg,#1e3a8a 0%,#1e40af 100%)", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", position: "sticky", top: 0, zIndex: 400, boxShadow: "0 2px 10px rgba(0,0,0,.3)" },
//   logoBadge: { width: 36, height: 36, borderRadius: 9, background: "linear-gradient(135deg,#f97316,#ea580c)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 16, color: "#fff", flexShrink: 0 },
//   rankBadge: { background: "rgba(255,255,255,.15)", border: "1px solid rgba(255,255,255,.3)", borderRadius: 99, padding: "3px 12px", fontSize: 11, fontWeight: 700, color: "#fef3c7" },
//   logoutBtn: { background: "rgba(239,68,68,.85)", border: "none", color: "#fff", padding: "6px 12px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 12, flexShrink: 0 },
//   sidebar: { width: 200, background: "#1e3a8a", minHeight: "calc(100vh - 56px)", flexShrink: 0 },
//   navItem: { color: "#bfdbfe", padding: "13px 16px", cursor: "pointer", display: "flex", alignItems: "center", fontSize: 13, borderBottom: "1px solid rgba(255,255,255,.06)", fontWeight: 500 },
//   navActive: { background: "#ea580c", color: "#fff" },
//   navSub: { color: "#93c5fd", padding: "11px 16px 11px 28px", cursor: "pointer", fontSize: 12, background: "rgba(0,0,0,.25)", borderBottom: "1px solid rgba(255,255,255,.04)" },
//   navSubActive: { background: "#ea580c", color: "#fff", fontWeight: 700 },
//   content: { flex: 1, padding: 16, overflowX: "hidden", minWidth: 0 },
//   kpiGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: 10, marginBottom: 16 },
//   kpiCard: { color: "#fff", borderRadius: 10, padding: "14px 16px", display: "flex", flexDirection: "column", gap: 4, boxShadow: "0 2px 8px rgba(0,0,0,.15)" },
//   card: { background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden" },
//   cardHead: { background: "#1e3a8a", color: "#fff", padding: "10px 16px", fontWeight: 700, fontSize: 13 },
//   tableWrap: { background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", overflowX: "auto", marginBottom: 16, WebkitOverflowScrolling: "touch" },
//   table: { width: "100%", borderCollapse: "collapse", minWidth: 480 },
//   td: { padding: "9px 10px", fontSize: 12, borderBottom: "1px solid #f1f5f9", verticalAlign: "middle", whiteSpace: "nowrap" },
//   trEven: { background: "#f8fafc" },
//   pill: { background: "#eff6ff", color: "#1d4ed8", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 600 },
//   greenBadge: { background: "#dcfce7", color: "#15803d", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   yellowBadge: { background: "#fef9c3", color: "#854d0e", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   redBadge: { background: "#fee2e2", color: "#991b1b", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
//   label: { display: "block", fontSize: 12, color: "#475569", marginBottom: 4, fontWeight: 600 },
//   input: { border: "1px solid #e2e8f0", padding: "9px 12px", width: "100%", fontSize: 13, borderRadius: 6, outline: "none", boxSizing: "border-box" },
//   btn: { color: "#fff", border: "none", padding: "7px 14px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13, display: "inline-flex", alignItems: "center", gap: 4 },
//   btnPrimary: { background: "#1e3a8a", color: "#fff", border: "none", padding: "9px 20px", borderRadius: 6, cursor: "pointer", fontWeight: 700, fontSize: 13 },
//   loginWrap: { minHeight: "100vh", background: "linear-gradient(135deg,#1e3a8a 0%,#1e40af 100%)", display: "flex", alignItems: "center", justifyContent: "center" },
//   loginBox: { background: "#fff", borderRadius: 14, padding: 40, width: 340, boxShadow: "0 24px 60px rgba(0,0,0,.25)" },
//   loginLogo: { width: 60, height: 60, borderRadius: 14, background: "linear-gradient(135deg,#f97316,#ea580c)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 24, color: "#fff", margin: "0 auto", boxShadow: "0 4px 16px rgba(234,88,12,.4)" },
// };



import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import api from "../api";
import toast from "react-hot-toast";

/* ── Inject mobile meta + global CSS once ── */
if (!document.getElementById("mlm-mobile-css")) {
  const meta = document.createElement("meta");
  meta.name = "viewport";
  meta.content = "width=device-width, initial-scale=1, maximum-scale=1";
  document.head.appendChild(meta);
  const style = document.createElement("style");
  style.id = "mlm-mobile-css";
  style.textContent = `
    * { box-sizing: border-box; }
    body { margin: 0; overflow-x: hidden; }
    input, select, textarea, button { font-size: 16px !important; }
    @media (max-width: 767px) {
      .mlm-hide-mobile { display: none !important; }
      .mlm-table-wrap { overflow-x: auto; -webkit-overflow-scrolling: touch; }
      .mlm-table-wrap table { min-width: 520px; }
      .mlm-flex-col { flex-direction: column !important; }
      .mlm-full { width: 100% !important; max-width: 100% !important; }
    }
  `;
  document.head.appendChild(style);
}

const LEVEL_RATE = { 1: 300, 2: 150, 3: 120, 4: 90, 5: 60, 6: 30 };
const PIE_COLORS = ["#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#06b6d4"];
const COMPANY = "Meruram";
const COMPANY_URL = "https://meruram.in";

const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const fmt = (d) => d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—";
const fmtTime = (d) => d ? new Date(d).toLocaleString("en-IN") : "—";
const whatsapp = (mobile, msg) => {
  if (!mobile) { toast.error("No mobile number!"); return; }
  window.open(`https://wa.me/91${mobile.replace(/\D/g, "")}?text=${encodeURIComponent(msg)}`, "_blank");
};

const NAV = [
  { label: "📊 Dashboard", key: "dashboard" },
  { label: "👤 Profile", key: "profile", children: ["My Profile", "Welcome Letter", "Change Password"] },
  { label: "👥 My Team", key: "myteam", children: ["Level Wise Report", "My Direct Tree", "Indirect Tree", "Date Wise Business"] },
  { label: "💹 My Incentive", key: "incentive", children: ["Direct Income", "Level Income", "Total Payout by Level", "Salary"] },
  { label: "💰 Wallet", key: "wallet", children: ["Wallet Report", "Withdrawal", "Withdrawal Detail"] },
  { label: "🎫 Support", key: "support", children: ["Raise Ticket", "Ticket Status"] },
];

/* ── Mobile detection hook ── */
function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return isMobile;
}

export default function AdminDashboard() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [token, setToken] = useState(() => localStorage.getItem("member_token") || "");
  const [tokenInput, setTokenInput] = useState("");
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("dashboard");
  const [subTab, setSubTab] = useState("");
  const [openNav, setOpenNav] = useState({});
  const [ticketForm, setTicketForm] = useState({ nature: "Support", description: "" });
  const [withdrawForm, setWithdrawForm] = useState({ amount: "", method: "upi" });
  const [bankForm, setBankForm] = useState({ bank_name: "", account_number: "", ifsc: "", upi_id: "" });

  useEffect(() => { if (token) fetchData(); }, [token]);

  const fetchData = async () => {
    try {
      const res = await api.get(`/mlm/my-stats/${token}`);
      setData(res.data);
    } catch { toast.error("Could not load data. Check your token."); }
  };

  const goTo = (t, s = "") => { setTab(t); setSubTab(s); setSidebarOpen(false); };

  const submitWithdraw = async () => {
    if (!withdrawForm.amount) { toast.error("Enter amount"); return; }
    try {
      await api.post(`/wallet/withdraw/${token}`, withdrawForm);
      toast.success("Withdrawal request submitted!");
      fetchData();
    } catch (err) { toast.error(err.response?.data?.message || "Error"); }
  };

  const saveBank = async () => {
    try { await api.put(`/wallet/bank/${token}`, bankForm); toast.success("Bank details saved!"); }
    catch { toast.error("Save failed"); }
  };

  /* ── Login screen ── */
  if (!token) {
    return (
      <div style={S.loginWrap}>
        <div style={S.loginBox}>
          <div style={{ textAlign: "center", marginBottom: 28 }}>
            <div style={S.loginLogo}>मे</div>
            <div style={{ fontWeight: 900, fontSize: 20, color: "#1e3a8a", marginTop: 10, letterSpacing: 1 }}>MERURAM</div>
            <div style={{ fontSize: 11, color: "#94a3b8", letterSpacing: 3, marginTop: 2 }}>MEMBER</div>
          </div>
          <label style={S.label}>Your Member Token / Coupon No.</label>
          <input style={S.input} placeholder="e.g. MLAB12345"
            value={tokenInput} onChange={e => setTokenInput(e.target.value)}
            onKeyDown={e => e.key === "Enter" && (() => { localStorage.setItem("member_token", tokenInput.trim()); setToken(tokenInput.trim()); })()}
          />
          <button style={{ ...S.btnPrimary, width: "100%", marginTop: 14, padding: 12 }}
            onClick={() => { localStorage.setItem("member_token", tokenInput.trim()); setToken(tokenInput.trim()); }}>
            Login →
          </button>
          <p style={{ textAlign: "center", fontSize: 12, color: "#94a3b8", marginTop: 16 }}>
            Not a member? <a href="/register" style={{ color: "#ea580c" }}>Register here</a>
          </p>
        </div>
      </div>
    );
  }

  if (!data) return <div style={{ padding: 60, textAlign: "center", color: "#94a3b8", fontSize: 16 }}>Loading your dashboard...</div>;

  const m = data.member;
  const stats = data.stats;
  const levelIncome = data.level_income || [];
  const levelPayout = data.level_payout || [];
  const directMembers = data.direct_members || [];
  const recentTxn = data.recent_transactions || [];
  const totalPayoutByLevel = data.total_payout_by_level || [];
  const allTeam = data.all_team || [];
  const totalIncome = levelIncome.reduce((s, l) => s + Number(l.total || 0), 0);

  const chartData = [1, 2, 3, 4, 5, 6].map(l => {
    const found = levelIncome.find(li => li.level === l);
    return { name: `L${l}`, earned: Number(found?.total || 0), members: found?.count || 0 };
  });

  const buildTree = () => {
    const map = {};
    map[m.token_number] = { ...m, children: [] };
    allTeam.forEach(member => {
      map[member.token_number] = { ...member, children: [] };
    });
    allTeam.forEach(member => {
      const parent = map[member.referred_by];
      if (parent) {
        if (!parent.children.find(c => c.token_number === member.token_number)) {
          parent.children.push(map[member.token_number]);
        }
      }
    });
    return map[m.token_number];
  };

  return (
    <div style={S.shell}>
      {isMobile && sidebarOpen && (
        <div onClick={() => setSidebarOpen(false)}
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", zIndex: 200 }} />
      )}

      {/* TOP BAR */}
      <header style={S.topbar}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {isMobile && (
            <button onClick={() => setSidebarOpen(o => !o)}
              style={{ background: "rgba(255,255,255,.15)", border: "none", color: "#fff",
                borderRadius: 7, padding: "6px 10px", fontSize: 18, cursor: "pointer", lineHeight: 1 }}>
              ☰
            </button>
          )}
          <div style={S.logoBadge}>मे</div>
          <div>
            <div style={{ fontWeight: 800, fontSize: isMobile ? 13 : 15, letterSpacing: .5 }}>MERURAM</div>
            {!isMobile && <div style={{ fontSize: 9, color: "#93c5fd", letterSpacing: 3 }}>MEMBER</div>}
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: isMobile ? 6 : 12 }}>
          <span style={{ ...S.rankBadge, display: isMobile ? "none" : undefined }}>🏆 {m.rank?.toUpperCase()}</span>
          <span style={{ fontSize: isMobile ? 11 : 12, color: "#ddd", maxWidth: isMobile ? 110 : "none", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {m.receiver_name}
          </span>
          <button style={S.logoutBtn} onClick={() => { logout(); navigate("/admin/login"); }}>
            {isMobile ? "Exit" : "Logout"}
          </button>
        </div>
      </header>

      <div style={{ display: "flex", flex: 1, position: "relative" }}>
        {/* SIDEBAR */}
        <nav style={{
          ...S.sidebar,
          ...(isMobile ? {
            position: "fixed", top: 0, left: 0, bottom: 0, zIndex: 300,
            width: 230, transform: sidebarOpen ? "translateX(0)" : "translateX(-100%)",
            transition: "transform .25s ease", overflowY: "auto", paddingTop: 56,
          } : {})
        }}>
          {NAV.map(n => (
            <div key={n.key}>
              <div style={{ ...S.navItem, ...(tab === n.key && !subTab && !n.children ? S.navActive : {}) }}
                onClick={() => n.children ? setOpenNav(p => ({ ...p, [n.key]: !p[n.key] })) : goTo(n.key)}>
                <span style={{ flex: 1 }}>{n.label}</span>
                {n.children && <span style={{ fontSize: 10, opacity: .6 }}>{openNav[n.key] ? "▾" : "▸"}</span>}
              </div>
              {n.children && openNav[n.key] && n.children.map(child => (
                <div key={child} style={{ ...S.navSub, ...(subTab === child ? S.navSubActive : {}) }}
                  onClick={() => goTo(n.key, child)}>{child}</div>
              ))}
            </div>
          ))}
          <div style={S.navItem} onClick={() => { logout(); navigate("/admin/login"); }}>🚪 Logout</div>
        </nav>

        {/* CONTENT */}
        <main style={{ ...S.content, padding: isMobile ? 12 : 20 }}>

          {/* ══════════ DASHBOARD ══════════ */}
          {tab === "dashboard" && !subTab && (
            <div>
              <PageHead title="My Dashboard" />
              <div style={{ ...S.kpiGrid, gridTemplateColumns: isMobile ? "repeat(2,1fr)" : "repeat(auto-fill, minmax(140px, 1fr))" }}>
                {[
                  { label: "Wallet Balance", val: inr(m.wallet_balance), icon: "💰", bg: "#065f46" },
                  { label: "Direct Members", val: stats.direct, icon: "👤", bg: "#1e40af" },
                  { label: "Total Team", val: stats.total_team, icon: "👥", bg: "#7f1d1d" },
                  { label: "Total Income", val: inr(totalIncome), icon: "📈", bg: "#4c1d95" },
                ].map(c => (
                  <div key={c.label} style={{ ...S.kpiCard, background: c.bg }}>
                    <div style={{ fontSize: 22 }}>{c.icon}</div>
                    <div style={{ fontSize: 20, fontWeight: 800 }}>{c.val}</div>
                    <div style={{ fontSize: 10, opacity: .8 }}>{c.label}</div>
                  </div>
                ))}
              </div>
              <SectionTitle>💹 Level Income at a Glance</SectionTitle>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
                {[1, 2, 3, 4, 5, 6].map(l => {
                  const found = levelIncome.find(li => li.level === l);
                  return (
                    <div key={l} style={{ background: PIE_COLORS[l - 1], color: "#fff", borderRadius: 10, padding: "12px 16px", minWidth: 80, textAlign: "center", boxShadow: "0 2px 6px rgba(0,0,0,.15)", flex: "1 1 80px" }}>
                      <div style={{ fontSize: 10, opacity: .8 }}>Level {l} · ₹{LEVEL_RATE[l]}/join</div>
                      <div style={{ fontSize: 17, fontWeight: 800 }}>{inr(found?.total || 0)}</div>
                      <div style={{ fontSize: 10, opacity: .8 }}>{found?.count || 0} members</div>
                    </div>
                  );
                })}
              </div>
              <div style={{ ...S.card, marginBottom: 16 }}>
                <div style={S.cardHead}>📊 My Level-wise Earnings Chart</div>
                <div style={{ padding: 16 }}>
                  <ResponsiveContainer width="100%" height={180}>
                    <BarChart data={chartData}>
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip formatter={v => inr(v)} />
                      <Bar dataKey="earned" fill="#1e3a8a" radius={[4, 4, 0, 0]} name="Earned" />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
              <div style={S.card}>
                <div style={S.cardHead}>🔗 Referral Link</div>
                <div style={{ padding: "12px 16px", display: "flex", gap: 8, alignItems: isMobile ? "stretch" : "center", flexWrap: "wrap", flexDirection: isMobile ? "column" : "row" }}>
                  <input readOnly style={{ ...S.input, flex: 1, background: "#f8fafc", color: "#475569", fontSize: 12, minWidth: 0 }}
                    value={data.referral_link} />
                  <button style={{ ...S.btn, background: "#1e3a8a" }}
                    onClick={() => { navigator.clipboard.writeText(data.referral_link); toast.success("Copied!"); }}>Copy</button>
                  <button style={{ ...S.btn, background: "#25D366" }}
                    onClick={() => whatsapp(m.receiver_mobile || "", `🎉 Join me on Meruram Lucky Draw!\n\nUse my referral link:\n${data.referral_link}\n\nGet exciting rewards when you join!`)}>
                    📱 Share
                  </button>
                </div>
              </div>
              {/* ══ BANK / UPI DETAILS — always visible on dashboard ══ */}
              <div style={{ ...S.card, marginTop: 16 }}>
                <div style={{ ...S.cardHead, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span>🏦 My Bank / UPI Details</span>
                  <button
                    style={{ background: "rgba(255,255,255,.18)", border: "1px solid rgba(255,255,255,.3)", color: "#fff", borderRadius: 6, padding: "3px 10px", fontSize: 11, cursor: "pointer", fontWeight: 600 }}
                    onClick={() => { setTab("wallet"); setSubTab("Withdrawal Detail"); }}
                  >✏️ Edit</button>
                </div>
                <div style={{ padding: "14px 16px" }}>
                  {(m.bank_name || m.account_number || m.ifsc || m.upi_id) ? (
                    <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                      {/* Bank details */}
                      {(m.bank_name || m.account_number || m.ifsc) && (
                        <div style={{ flex: "1 1 200px", display: "flex", flexDirection: "column", gap: 8 }}>
                          {m.bank_name && (
                            <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 12px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0" }}>
                              <span style={{ fontSize: 18 }}>🏦</span>
                              <div>
                                <div style={{ fontSize: 10, color: "#94a3b8", marginBottom: 1 }}>Bank</div>
                                <div style={{ fontWeight: 700, fontSize: 13, color: "#1e293b" }}>{m.bank_name}</div>
                              </div>
                            </div>
                          )}
                          {m.account_number && (
                            <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 12px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0" }}>
                              <span style={{ fontSize: 18 }}>🔢</span>
                              <div>
                                <div style={{ fontSize: 10, color: "#94a3b8", marginBottom: 1 }}>A/C No</div>
                                <div style={{ fontWeight: 700, fontSize: 13, color: "#1e293b", fontFamily: "monospace", letterSpacing: 1 }}>{m.account_number}</div>
                              </div>
                            </div>
                          )}
                          {m.ifsc && (
                            <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 12px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0" }}>
                              <span style={{ fontSize: 18 }}>🏷️</span>
                              <div>
                                <div style={{ fontSize: 10, color: "#94a3b8", marginBottom: 1 }}>IFSC</div>
                                <div style={{ fontWeight: 700, fontSize: 13, color: "#1e293b" }}>{m.ifsc}</div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {/* UPI */}
                      {m.upi_id && (
                        <div style={{ flex: "1 1 160px" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 12px", background: "#f0fdf4", borderRadius: 8, border: "1px solid #bbf7d0", height: "100%", minHeight: 56 }}>
                            <span style={{ fontSize: 22 }}>📱</span>
                            <div>
                              <div style={{ fontSize: 10, color: "#15803d", marginBottom: 1 }}>UPI ID</div>
                              <div style={{ fontWeight: 700, fontSize: 13, color: "#064e3b", wordBreak: "break-all" }}>{m.upi_id}</div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0" }}>
                      <span style={{ fontSize: 28, opacity: .4 }}>🏦</span>
                      <div>
                        <div style={{ fontSize: 12, color: "#94a3b8" }}>No bank/UPI details saved yet.</div>
                        <button
                          style={{ ...S.btn, background: "#1e3a8a", marginTop: 6, fontSize: 11, padding: "5px 14px" }}
                          onClick={() => { setTab("wallet"); setSubTab("Withdrawal Detail"); }}
                        >➕ Add Bank Details</button>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <SectionTitle>👥 My Direct Members</SectionTitle>
              {isMobile && <div style={{ fontSize: 11, color: "#94a3b8", marginBottom: 6, textAlign: "right" }}>← Swipe table to scroll →</div>}
              <div style={S.tableWrap}>
                <table style={S.table}>
                  <THead cols={["#", "Coupon", "Name", "Mobile", "Their Direct", "Joined", "Status"]} />
                  <tbody>
                    {directMembers.slice(0, 10).map((d, i) => (
                      <tr key={d.token_number || d.id} style={i % 2 === 0 ? S.trEven : {}}>
                        <td style={S.td}>{i + 1}</td>
                        <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{d.receiver_coupon_no}</td>
                        <td style={S.td}>{d.receiver_name}</td>
                        <td style={S.td}>{d.receiver_mobile}</td>
                        <td style={S.td}>{d.their_direct}</td>
                        <td style={{ ...S.td, fontSize: 11 }}>{fmt(d.created_at)}</td>
                        <td style={S.td}><span style={d.is_approved ? S.greenBadge : S.yellowBadge}>{d.is_approved ? "Active" : "Pending"}</span></td>
                      </tr>
                    ))}
                    {directMembers.length === 0 && (
                      <tr><td colSpan={7} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 24 }}>
                        No direct members yet. Share your referral link!
                      </td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ══════════ LEVEL WISE REPORT ══════════ */}
          {subTab === "Level Wise Report" && (
            <div>
              <PageHead title="📊 Level Wise Report" />
              <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
                {[["Direct Members", stats.direct, "#1e40af"], ["Indirect Members", stats.total_team - stats.direct, "#7c3aed"], ["Total Team", stats.total_team, "#065f46"]].map(([label, val, bg]) => (
                  <div key={label} style={{ ...S.kpiCard, background: bg, flex: 1, minWidth: 140 }}>
                    <div style={{ fontSize: 26, fontWeight: 800 }}>{val}</div>
                    <div style={{ fontSize: 12, opacity: .85 }}>{label}</div>
                  </div>
                ))}
              </div>

              <SectionTitle>👤 Level 1 — Your Direct Members ({directMembers.length})</SectionTitle>
              <div style={S.tableWrap}>
                <table style={S.table}>
                  <THead cols={["#", "Coupon", "Name", "Mobile", "Connected By", "Their Direct", "Joined At", "Status", "WA"]} />
                  <tbody>
                    {directMembers.map((d, i) => (
                      <tr key={d.token_number || d.id} style={i % 2 === 0 ? S.trEven : {}}>
                        <td style={S.td}>{i + 1}</td>
                        <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{d.receiver_coupon_no}</td>
                        <td style={S.td}>{d.receiver_name}</td>
                        <td style={S.td}>{d.receiver_mobile}</td>
                        <td style={{ ...S.td, color: "#16a34a", fontWeight: 600 }}>
                          {m.receiver_name} ({m.receiver_coupon_no}) ← You
                        </td>
                        <td style={{ ...S.td, fontWeight: 700, color: "#7c3aed" }}>{d.their_direct}</td>
                        <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(d.created_at)}</td>
                        <td style={S.td}><span style={d.is_approved ? S.greenBadge : S.yellowBadge}>{d.is_approved ? "Active" : "Pending"}</span></td>
                        <td style={S.td}>
                          <button style={{ ...S.btn, background: "#25D366", padding: "4px 8px", fontSize: 12 }}
                            onClick={() => whatsapp(d.receiver_mobile, `Namaste ${d.receiver_name}! Meruram Lucky Draw update. Login: ${COMPANY_URL}`)}>📱</button>
                        </td>
                      </tr>
                    ))}
                    {directMembers.length === 0 && <tr><td colSpan={9} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No direct members yet</td></tr>}
                  </tbody>
                </table>
              </div>

              {[2, 3, 4, 5, 6].map(lvl => {
                const members = allTeam.filter(t => Number(t.lvl) === lvl);
                if (members.length === 0) return null;
                return (
                  <div key={lvl}>
                    <SectionTitle>🔗 Level {lvl} — Indirect Members ({members.length}) · Earn ₹{LEVEL_RATE[lvl]} per join</SectionTitle>
                    <div style={S.tableWrap}>
                      <table style={S.table}>
                        <THead cols={["#", "Coupon", "Name", "Mobile", "Connected Via (Sponsor)", "Rank", "Joined At", "Status"]} />
                        <tbody>
                          {members.map((member, i) => {
                            const sponsorInTeam = allTeam.find(t => t.token_number === member.referred_by);
                            const sponsorInDirect = directMembers.find(d => d.token_number === member.referred_by);
                            const sponsor = sponsorInTeam || sponsorInDirect;
                            const sponsorLabel = sponsor
                              ? `${sponsor.receiver_name} (${sponsor.receiver_coupon_no})`
                              : member.referred_by ? `Token #${member.referred_by}` : "—";
                            return (
                              <tr key={member.token_number} style={i % 2 === 0 ? S.trEven : {}}>
                                <td style={S.td}>{i + 1}</td>
                                <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{member.receiver_coupon_no}</td>
                                <td style={S.td}>{member.receiver_name}</td>
                                <td style={S.td}>{member.receiver_mobile}</td>
                                <td style={{ ...S.td, color: "#7c3aed", fontWeight: 600 }}>{sponsorLabel}</td>
                                <td style={S.td}><span style={S.pill}>{member.rank || "member"}</span></td>
                                <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(member.created_at)}</td>
                                <td style={S.td}><span style={member.is_approved ? S.greenBadge : S.yellowBadge}>{member.is_approved ? "Active" : "Pending"}</span></td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              })}

              {allTeam.length === 0 && (
                <div style={{ textAlign: "center", padding: 40, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0", marginTop: 12 }}>
                  No indirect members yet. Your direct members need to start referring.
                </div>
              )}
            </div>
          )}

          {/* ══════════ MY DIRECT TREE ══════════ */}
          {subTab === "My Direct Tree" && (
            <div>
              <PageHead title="🌳 My Direct Tree" />
              <div style={{ ...S.card, padding: isMobile ? 12 : 20, overflowX: "auto" }}>
                <div style={{ display: "flex", justifyContent: "center", minWidth: isMobile ? 300 : Math.max(400, directMembers.length * 130) }}>
                  <TreeBoxNode
                    name={m.receiver_name}
                    coupon={m.receiver_coupon_no}
                    isRoot
                    subCount={directMembers.length}
                    children={directMembers.map(d => ({
                      name: d.receiver_name,
                      coupon: d.receiver_coupon_no,
                      mobile: d.receiver_mobile,
                      isApproved: !!d.is_approved,
                      subCount: d.their_direct,
                    }))}
                  />
                </div>
              </div>
              <p style={{ fontSize: 12, color: "#64748b", marginTop: 10, textAlign: "center" }}>
                Shows your direct referrals (Level 1). Number below each node = their own direct count.
              </p>
            </div>
          )}

          {/* ══════════ INDIRECT TREE ══════════ */}
          {subTab === "Indirect Tree" && (
            <div>
              <PageHead title="🌐 My Full Network Tree (All 6 Levels)" />
              {allTeam.length === 0 && directMembers.length === 0 ? (
                <div style={{ textAlign: "center", padding: 60, color: "#94a3b8", background: "#f8fafc", borderRadius: 8, border: "2px dashed #e2e8f0" }}>
                  <div style={{ fontSize: 40, marginBottom: 12 }}>🌐</div>
                  <div style={{ fontWeight: 700 }}>No team members yet</div>
                  <div style={{ fontSize: 12, marginTop: 8 }}>Share your referral link to build your network</div>
                </div>
              ) : (
                <>
                  <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
                    {[1, 2, 3, 4, 5, 6].map(lvl => {
                      const count = allTeam.filter(t => Number(t.lvl) === lvl).length;
                      return (
                        <div key={lvl} style={{ background: PIE_COLORS[lvl - 1], color: "#fff", borderRadius: 8, padding: "10px 14px", minWidth: 90, textAlign: "center", flex: 1 }}>
                          <div style={{ fontSize: 10, opacity: .8 }}>Level {lvl}</div>
                          <div style={{ fontSize: 22, fontWeight: 800 }}>{count}</div>
                          <div style={{ fontSize: 10, opacity: .8 }}>members</div>
                        </div>
                      );
                    })}
                  </div>
                  <div style={{ ...S.card, padding: isMobile ? 8 : 16, maxHeight: isMobile ? 400 : 600, overflowY: "auto" }}>
                    <ExpandableTreeNode node={buildTree()} depth={0} isRoot />
                  </div>
                  <div style={{ display: "flex", gap: 10, marginTop: 10, flexWrap: "wrap" }}>
                    {PIE_COLORS.map((c, i) => (
                      <div key={i} style={{ display: "flex", alignItems: "center", gap: 5 }}>
                        <div style={{ width: 12, height: 12, borderRadius: 3, background: c }} />
                        <span style={{ fontSize: 11, color: "#64748b" }}>Level {i + 1}</span>
                      </div>
                    ))}
                    <div style={{ fontSize: 11, color: "#94a3b8", marginLeft: "auto" }}>Click ▶ to expand • Shows up to 6 levels</div>
                  </div>
                </>
              )}
            </div>
          )}

          {/* ══════════ DATE WISE BUSINESS ══════════ */}
          {subTab === "Date Wise Business" && (
            <DateWiseBusiness directMembers={directMembers} allTeam={allTeam} />
          )}

          {/* ══════════ DIRECT INCOME ══════════ */}
          {subTab === "Direct Income" && (
            <div>
              <PageHead title="💹 Direct Income Summary" />
              <div style={S.tableWrap}>
                <table style={S.table}>
                  <THead cols={["S.No", "Id No", "Member Name", "Trade Income", "Direct Income", "Level Income", "Salary Income", ""]} />
                  <tbody>
                    <tr style={S.trEven}>
                      <td style={S.td}>1</td>
                      <td style={{ ...S.td, fontWeight: 700, color: "#1d4ed8" }}>{m.receiver_coupon_no}</td>
                      <td style={S.td}>{m.receiver_name}</td>
                      <td style={S.td}>₹0.00</td>
                      <td style={{ ...S.td, color: "#16a34a", fontWeight: 700 }}>{inr(stats.direct * LEVEL_RATE[1])}</td>
                      <td style={{ ...S.td, color: "#7c3aed", fontWeight: 700 }}>{inr(totalIncome)}</td>
                      <td style={S.td}>{inr(data.salary?.amount || 0)}</td>
                      {/* <td style={{ ...S.td, fontWeight: 800, color: "#16a34a", fontSize: 15 }}>
                        {inr(stats.direct * LEVEL_RATE[1] + totalIncome + (data.salary?.amount || 0))}
                      </td> */}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ══════════ LEVEL INCOME ══════════ */}
          {subTab === "Level Income" && (
            <div>
              <PageHead title="📈 Level Income — Detailed" />
              <div style={S.tableWrap}>
                <table style={S.table}>
                  <THead cols={["#", "Date", "Level", "Member Name", "Coupon", "Mobile", "Amount"]} />
                  <tbody>
                    {levelPayout.map((p, i) => (
                      <tr key={i} style={i % 2 === 0 ? S.trEven : {}}>
                        <td style={S.td}>{i + 1}</td>
                        <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(p.created_at)}</td>
                        <td style={S.td}>
                          <span style={{ ...S.pill, background: PIE_COLORS[(p.level - 1) % 6] + "22", color: PIE_COLORS[(p.level - 1) % 6], border: `1px solid ${PIE_COLORS[(p.level - 1) % 6]}` }}>
                            L{p.level}
                          </span>
                        </td>
                        <td style={{ ...S.td, fontWeight: 600 }}>{p.from_name || "—"}</td>
                        <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 700 }}>{p.from_coupon || p.from_token}</td>
                        <td style={{ ...S.td, fontSize: 11, color: "#64748b" }}>{p.from_mobile || "—"}</td>
                        <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(p.amount)}</td>
                      </tr>
                    ))}
                    {levelPayout.length === 0 && (
                      <tr><td colSpan={7} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 32 }}>No income credited yet</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ══════════ TOTAL PAYOUT BY LEVEL ══════════ */}
          {subTab === "Total Payout by Level" && (
            <div>
              <PageHead title="💸 Total Payout — Level-wise Breakdown" />
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
                {[1, 2, 3, 4, 5, 6].map(l => {
                  const found = totalPayoutByLevel.find(li => li.level === l);
                  const earned = Number(found?.total || 0);
                  return (
                    <div key={l} style={{ background: "#fff", border: `2px solid ${PIE_COLORS[l - 1]}`, borderRadius: 10, padding: "14px 18px", minWidth: 90, flex: "1 1 90px", textAlign: "center" }}>
                      <div style={{ fontSize: 11, color: "#64748b" }}>Level {l}</div>
                      <div style={{ fontSize: 11, color: "#94a3b8" }}>₹{LEVEL_RATE[l]}/join</div>
                      <div style={{ fontSize: 20, fontWeight: 800, color: PIE_COLORS[l - 1], margin: "6px 0" }}>{inr(earned)}</div>
                      <div style={{ fontSize: 11, color: "#64748b" }}>{found?.count || 0} payouts</div>
                    </div>
                  );
                })}
              </div>
              <SectionTitle>Payout Summary Table</SectionTitle>
              <div style={S.tableWrap}>
                <table style={S.table}>
                  <THead cols={["Level", "Rate/Join ₹", "Members Paid", "Total Amount Received", "% of Total Earnings"]} />
                  <tbody>
                    {[1, 2, 3, 4, 5, 6].map((level, i) => {
                      const found = totalPayoutByLevel.find(l => l.level === level);
                      const earned = Number(found?.total || 0);
                      const pct = totalIncome > 0 ? ((earned / totalIncome) * 100).toFixed(1) : "0";
                      return (
                        <tr key={level} style={i % 2 === 0 ? S.trEven : {}}>
                          <td style={S.td}><b>Level {level}</b> {level === 1 ? "🔴 Direct" : level <= 3 ? "🟡 Close" : "🟢 Deep"}</td>
                          <td style={S.td}>₹{LEVEL_RATE[level]}</td>
                          <td style={S.td}>{found?.count || 0}</td>
                          <td style={{ ...S.td, fontWeight: 700, color: earned > 0 ? "#16a34a" : "#94a3b8", fontSize: 14 }}>
                            {earned > 0 ? inr(earned) : "₹0.00"}
                          </td>
                          <td style={S.td}>
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                              <div style={{ flex: 1, height: 8, background: "#f1f5f9", borderRadius: 99, overflow: "hidden" }}>
                                <div style={{ height: "100%", width: `${Math.min(Number(pct), 100)}%`, background: PIE_COLORS[i], borderRadius: 99, transition: "width .5s" }} />
                              </div>
                              <span style={{ fontSize: 11, color: "#64748b", minWidth: 32 }}>{pct}%</span>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                    <tr style={{ background: "#f0fdf4" }}>
                      <td style={{ ...S.td, fontWeight: 800 }} colSpan={2}>GRAND TOTAL</td>
                      <td style={{ ...S.td, fontWeight: 700 }}>{totalPayoutByLevel.reduce((s, l) => s + l.count, 0)}</td>
                      <td style={{ ...S.td, fontWeight: 800, color: "#15803d", fontSize: 16 }}>{inr(totalIncome)}</td>
                      <td style={S.td}><span style={S.greenBadge}>100%</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <SectionTitle>📋 Detailed — Who Joined & Earned Me Commission</SectionTitle>
              <p style={{ fontSize: 12, color: "#64748b", marginBottom: 10 }}>
                Each row = one join event. Level 1 = your direct referral. Level 2–6 = their downline under your network.
              </p>
              <div style={S.tableWrap}>
                <table style={S.table}>
                  <THead cols={["#", "Date", "Level", "Member Name", "Coupon", "Mobile", "Commission", "Note"]} />
                  <tbody>
                    {levelPayout.map((p, i) => (
                      <tr key={i} style={i % 2 === 0 ? S.trEven : {}}>
                        <td style={S.td}>{i + 1}</td>
                        <td style={{ ...S.td, fontSize: 11 }}>{fmt(p.created_at)}</td>
                        <td style={S.td}>
                          <span style={{ ...S.pill, background: PIE_COLORS[(p.level - 1) % 6] + "22", color: PIE_COLORS[(p.level - 1) % 6] }}>L{p.level}</span>
                        </td>
                        <td style={{ ...S.td, fontWeight: 600 }}>{p.from_name || "—"}</td>
                        <td style={{ ...S.td, color: "#1d4ed8", fontWeight: 600 }}>{p.from_coupon || p.from_token}</td>
                        <td style={{ ...S.td, fontSize: 11, color: "#64748b" }}>{p.from_mobile || "—"}</td>
                        <td style={{ ...S.td, fontWeight: 700, color: "#16a34a" }}>{inr(p.amount)}</td>
                        <td style={{ ...S.td, fontSize: 11, color: "#64748b" }}>
                          {p.level === 1 ? "Your direct referral joined" : `Level ${p.level} downline joined`}
                        </td>
                      </tr>
                    ))}
                    {levelPayout.length === 0 && (
                      <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 32 }}>
                        No commission history yet. Start referring!
                      </td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ══════════ SALARY ══════════ */}
          {subTab === "Salary" && (
            <div>
              <PageHead title="💰 Salary Details" />
              <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
                <div style={{ ...S.card, padding: 20, textAlign: "center", minWidth: "min(180px, 45%)" }}>
                  <div style={{ fontSize: 11, color: "#64748b" }}>Current Rank</div>
                  <div style={{ fontSize: 22, fontWeight: 800, color: "#1e3a8a", margin: "8px 0" }}>{m.rank?.toUpperCase()}</div>
                </div>
                <div style={{ ...S.card, padding: 20, textAlign: "center", minWidth: "min(180px, 45%)" }}>
                  <div style={{ fontSize: 11, color: "#64748b" }}>This Month's Salary</div>
                  <div style={{ fontSize: 22, fontWeight: 800, color: "#16a34a", margin: "8px 0" }}>{inr(data.salary?.amount || 0)}</div>
                  <span style={data.salary?.is_approved ? S.greenBadge : S.yellowBadge}>
                    {data.salary?.is_approved ? "Paid ✅" : data.salary ? "Pending" : "Not Generated"}
                  </span>
                </div>
              </div>
              <div style={{ ...S.card, padding: 16 }}>
                <div style={S.cardHead}>Rank Salary Chart</div>
                <div style={{ padding: 16 }}>
                  {[["Member", 0], ["Silver", 1000], ["Gold", 3000], ["Platinum", 7000], ["Diamond", 15000]].map(([rank, amt]) => (
                    <div key={rank} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #f1f5f9", alignItems: "center" }}>
                      <span style={{ fontWeight: 600 }}>
                        {rank.toLowerCase() === m.rank?.toLowerCase() ? `✅ ${rank} ← You` : rank}
                      </span>
                      <span style={{ fontWeight: 700, color: amt > 0 ? "#16a34a" : "#94a3b8" }}>
                        {amt > 0 ? inr(amt) + "/month" : "No salary"}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* ══════════ WALLET REPORT ══════════ */}
          {subTab === "Wallet Report" && (
            <div>
              <PageHead title="📊 Wallet Report" />
              <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
                {[["Earning Wallet", m.wallet_balance, "#1e3a8a"], ["Salary Wallet", data.salary?.amount || 0, "#065f46"], ["Total Withdrawn", recentTxn.filter(t => t.type === "debit").reduce((s, t) => s + Number(t.amount), 0), "#7f1d1d"]].map(([label, val, bg]) => (
                  <div key={label} style={{ ...S.kpiCard, background: bg, flex: 1, minWidth: 150 }}>
                    <div style={{ fontSize: 11, opacity: .8 }}>{label}</div>
                    <div style={{ fontSize: 20, fontWeight: 800 }}>{inr(val)}</div>
                  </div>
                ))}
              </div>
              <SectionTitle>Recent Transactions</SectionTitle>
              <div style={S.tableWrap}>
                <table style={S.table}>
                  <THead cols={["#", "Date", "Type", "Description", "Amount"]} />
                  <tbody>
                    {recentTxn.map((t, i) => (
                      <tr key={t.id} style={i % 2 === 0 ? S.trEven : {}}>
                        <td style={S.td}>{i + 1}</td>
                        <td style={{ ...S.td, fontSize: 11 }}>{fmtTime(t.created_at)}</td>
                        <td style={S.td}><span style={t.type === "credit" ? S.greenBadge : S.redBadge}>{t.type}</span></td>
                        <td style={S.td}>{t.description}</td>
                        <td style={{ ...S.td, fontWeight: 700, color: t.type === "credit" ? "#16a34a" : "#dc2626" }}>
                          {t.type === "credit" ? "+" : "−"}{inr(t.amount)}
                        </td>
                      </tr>
                    ))}
                    {recentTxn.length === 0 && <tr><td colSpan={5} style={{ ...S.td, textAlign: "center", color: "#94a3b8" }}>No transactions yet</td></tr>}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ══════════ WITHDRAWAL ══════════ */}
          {subTab === "Withdrawal" && (
            <div>
              <PageHead title="💸 Request Withdrawal" />
              <div style={{ ...S.card, maxWidth: "min(480px, 100%)" }}>
                <div style={S.cardHead}>Withdrawal Request</div>
                <div style={{ padding: "16px" }}>
                  <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 8, padding: 14, marginBottom: 16, textAlign: "center" }}>
                    <div style={{ fontSize: 11, color: "#15803d" }}>Available Balance</div>
                    <div style={{ fontSize: 26, fontWeight: 900, color: "#15803d" }}>{inr(m.wallet_balance)}</div>
                  </div>
                  <div style={{ marginBottom: 12 }}>
                    <label style={S.label}>Amount (₹) *</label>
                    <input style={S.input} type="number" value={withdrawForm.amount}
                      onChange={e => setWithdrawForm({ ...withdrawForm, amount: e.target.value })} />
                  </div>
                  <div style={{ marginBottom: 16 }}>
                    <label style={S.label}>Method *</label>
                    <select style={S.input} value={withdrawForm.method}
                      onChange={e => setWithdrawForm({ ...withdrawForm, method: e.target.value })}>
                      <option value="upi">UPI</option>
                      <option value="bank">Bank Transfer</option>
                    </select>
                  </div>
                  <button style={{ ...S.btn, background: "#1e3a8a", width: "100%", padding: 12, fontSize: 14 }}
                    onClick={submitWithdraw}>Submit Withdrawal Request</button>
                </div>
              </div>
            </div>
          )}

          {/* ══════════ WITHDRAWAL DETAIL — two-column: form left, preview right ══════════ */}
          {subTab === "Withdrawal Detail" && (
            <WithdrawalDetailPanel token={token} existingBank={m} />
          )}

          {/* ══════════ RAISE TICKET ══════════ */}
          {subTab === "Raise Ticket" && (
            <div>
              <PageHead title="🎫 Raise Support Ticket" />
              <div style={{ ...S.card, maxWidth: "min(560px, 100%)" }}>
                <div style={S.cardHead}>Submit a Ticket</div>
                <div style={{ padding: "16px" }}>
                  {[["Username", m.receiver_coupon_no, true], ["Name", m.receiver_name, true], ["Mobile No", m.receiver_mobile || "", true]].map(([label, val, ro]) => (
                    <div key={label} style={{ marginBottom: 12 }}>
                      <label style={S.label}>{label} *</label>
                      <input style={{ ...S.input, background: ro ? "#f8fafc" : "#fff" }} value={val} readOnly={ro} />
                    </div>
                  ))}
                  <div style={{ marginBottom: 12 }}>
                    <label style={S.label}>Nature of Grievance *</label>
                    <select style={S.input} value={ticketForm.nature}
                      onChange={e => setTicketForm({ ...ticketForm, nature: e.target.value })}>
                      <option>Support</option><option>Technical</option><option>Payment</option><option>Other</option>
                    </select>
                  </div>
                  <div style={{ marginBottom: 16 }}>
                    <label style={S.label}>Description *</label>
                    <textarea style={{ ...S.input, height: 90, resize: "vertical" }}
                      value={ticketForm.description}
                      onChange={e => setTicketForm({ ...ticketForm, description: e.target.value })}
                      placeholder="Describe your issue in detail..." />
                  </div>
                  <button style={{ ...S.btn, background: "#1e3a8a", width: "100%", padding: 12 }}
                    onClick={() => {
                      if (!ticketForm.description) { toast.error("Please enter description"); return; }
                      const msg = `🛑 Support Ticket - ${COMPANY}\n\n👤 Name: ${m.receiver_name}\n🆔 ID: ${m.receiver_coupon_no}\n📱 Mobile: ${m.receiver_mobile || "N/A"}\n📌 Nature: ${ticketForm.nature}\n\n📝 Issue:\n${ticketForm.description}\n\n📅 Date: ${new Date().toLocaleString("en-IN")}`;
                      window.open("https://wa.me/918275547499?text=" + encodeURIComponent(msg), "_blank");
                      toast.success("Redirecting to WhatsApp Support...");
                      setTicketForm({ nature: "Support", description: "" });
                    }}>
                    Submit Ticket via WhatsApp 📱
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* ══════════ MY PROFILE ══════════ */}
          {subTab === "My Profile" && (
            <div>
              <PageHead title="👤 My Profile" />

              {/* ── Profile Details ── */}
              <div style={{ ...S.card, maxWidth: "min(600px, 100%)", marginBottom: 20 }}>
                <div style={S.cardHead}>Profile Details</div>
                <div style={{ padding: 24 }}>
                  {[
                    ["Full Name", m.receiver_name],
                    ["User ID / Coupon", m.receiver_coupon_no],
                    ["Mobile Number", m.receiver_mobile],
                    ["Joining Date", fmt(m.created_at)],
                    ["Current Rank", m.rank?.toUpperCase()],
                    ["Wallet Balance", inr(m.wallet_balance)],
                    ["Direct Members", stats.direct],
                    ["Total Team", stats.total_team],
                  ].map(([label, value]) => (
                    <div key={label} style={{ display: "flex", justifyContent: "space-between", padding: "12px 0", borderBottom: "1px solid #f1f5f9" }}>
                      <span style={{ color: "#64748b" }}>{label}</span>
                      <span style={{ fontWeight: 700 }}>{value || "—"}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* ── Bank / UPI Details Card ── */}
              <div style={{ maxWidth: "min(600px, 100%)" }}>
                <div style={{ fontWeight: 700, fontSize: 13, color: "#1e3a8a", marginBottom: 10, borderLeft: "4px solid #ea580c", paddingLeft: 10 }}>
                  🏦 My Bank / UPI Details
                </div>

                {(m.bank_name || m.account_number || m.ifsc || m.upi_id) ? (
                  <div>
                    {/* Bank card visual */}
                    <div style={{
                      background: "linear-gradient(135deg, #1e3a8a 0%, #1d4ed8 55%, #3b82f6 100%)",
                      borderRadius: 16, padding: "22px 22px 18px", color: "#fff",
                      boxShadow: "0 8px 28px rgba(30,58,138,.32)",
                      position: "relative", overflow: "hidden", marginBottom: 12,
                    }}>
                      <div style={{ position: "absolute", top: -24, right: -24, width: 100, height: 100, borderRadius: "50%", background: "rgba(255,255,255,.08)" }} />
                      <div style={{ position: "absolute", bottom: -30, left: -12, width: 120, height: 120, borderRadius: "50%", background: "rgba(255,255,255,.05)" }} />

                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
                        <div>
                          <div style={{ fontSize: 9, opacity: .65, letterSpacing: 2.5, marginBottom: 3 }}>BANK NAME</div>
                          <div style={{ fontSize: 16, fontWeight: 800 }}>{m.bank_name || "—"}</div>
                        </div>
                        <div style={{ fontSize: 30 }}>🏦</div>
                      </div>

                      <div style={{ marginBottom: 16 }}>
                        <div style={{ fontSize: 9, opacity: .65, letterSpacing: 2.5, marginBottom: 3 }}>ACCOUNT NUMBER</div>
                        <div style={{ fontSize: 17, fontWeight: 700, letterSpacing: 4, fontFamily: "monospace" }}>
                          {m.account_number ? m.account_number.replace(/(.{4})/g, "$1 ").trim() : "—"}
                        </div>
                      </div>

                      <div style={{ display: "flex", gap: 28 }}>
                        <div>
                          <div style={{ fontSize: 9, opacity: .65, letterSpacing: 2.5, marginBottom: 2 }}>IFSC CODE</div>
                          <div style={{ fontSize: 13, fontWeight: 700 }}>{m.ifsc || "—"}</div>
                        </div>
                        <div>
                          <div style={{ fontSize: 9, opacity: .65, letterSpacing: 2.5, marginBottom: 2 }}>ACCOUNT TYPE</div>
                          <div style={{ fontSize: 13, fontWeight: 700 }}>SAVINGS</div>
                        </div>
                      </div>
                    </div>

                    {/* UPI card */}
                    {m.upi_id && (
                      <div style={{
                        background: "linear-gradient(135deg, #064e3b 0%, #065f46 100%)",
                        borderRadius: 12, padding: "14px 18px", color: "#fff",
                        boxShadow: "0 5px 16px rgba(6,79,59,.28)",
                        display: "flex", alignItems: "center", gap: 14, marginBottom: 12,
                      }}>
                        <div style={{ fontSize: 30 }}>📱</div>
                        <div>
                          <div style={{ fontSize: 9, opacity: .7, letterSpacing: 2.5, marginBottom: 3 }}>UPI ID</div>
                          <div style={{ fontSize: 14, fontWeight: 800 }}>{m.upi_id}</div>
                          <div style={{ fontSize: 11, opacity: .7, marginTop: 2 }}>Instant transfer ready</div>
                        </div>
                      </div>
                    )}

                    {/* Status + Edit button */}
                    <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "11px 14px", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 9 }}>
                      <span style={{ fontSize: 18 }}>✅</span>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: "#15803d" }}>Bank Details Saved</div>
                        <div style={{ fontSize: 11, color: "#16a34a" }}>Go to Wallet → Withdrawal Detail to update</div>
                      </div>
                      <button
                        style={{ ...S.btn, background: "#1e3a8a", fontSize: 11, padding: "6px 12px" }}
                        onClick={() => { setTab("wallet"); setSubTab("Withdrawal Detail"); }}
                      >
                        ✏️ Edit
                      </button>
                    </div>
                  </div>
                ) : (
                  /* No bank details yet */
                  <div style={{
                    border: "2px dashed #cbd5e1", borderRadius: 12, padding: "28px 20px",
                    textAlign: "center", background: "#f8fafc",
                    display: "flex", flexDirection: "column", alignItems: "center", gap: 8,
                  }}>
                    <div style={{ fontSize: 40 }}>🏦</div>
                    <div style={{ fontWeight: 700, fontSize: 13, color: "#64748b" }}>No Bank Details Added Yet</div>
                    <div style={{ fontSize: 12, color: "#94a3b8" }}>Add your bank/UPI details to receive withdrawals</div>
                    <button
                      style={{ ...S.btn, background: "#1e3a8a", marginTop: 6, padding: "8px 20px" }}
                      onClick={() => { setTab("wallet"); setSubTab("Withdrawal Detail"); }}
                    >
                      ➕ Add Bank Details
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* ══════════ WELCOME LETTER ══════════ */}
          {subTab === "Welcome Letter" && (
            <div>
              <PageHead title="📄 Welcome Letter" />
              <div style={{ ...S.card, maxWidth: "min(600px, 100%)" }}>
                <div style={S.cardHead}>Official Welcome Letter — Meruram</div>
                <div style={{ padding: 24 }}>
                  <p style={{ fontWeight: 700, marginBottom: 4 }}>Welcome to {COMPANY}!</p>
                  <p style={{ fontStyle: "italic", color: "#64748b", marginBottom: 16 }}>Dear {m.receiver_name},</p>
                  <p style={{ fontSize: 13, lineHeight: 1.8, color: "#475569", marginBottom: 20 }}>
                    We are delighted to have you as a member of our growing Meruram family. Participate, refer friends, and earn exciting rewards at every level.
                    <br /><br />
                    Visit us at: <a href={COMPANY_URL} style={{ color: "#ea580c", fontWeight: 600 }}>{COMPANY_URL}</a>
                  </p>
                  <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden" }}>
                    {[["Member Name", m.receiver_name], ["Member ID / Coupon", m.receiver_coupon_no],
                      ["Joining Date", fmt(m.created_at)], ["Current Rank", m.rank?.toUpperCase()],
                      ["Wallet Balance", inr(m.wallet_balance)]].map(([k, v], idx) => (
                      <div key={k} style={{ display: "flex", padding: "11px 16px", borderBottom: "1px solid #e2e8f0", background: idx % 2 === 0 ? "#fff" : "#f8fafc" }}>
                        <div style={{ width: 180, color: "#64748b", fontSize: 13 }}>{k}</div>
                        <div style={{ fontWeight: 700, fontSize: 13 }}>: {v}</div>
                      </div>
                    ))}
                  </div>
                  <div style={{ marginTop: 20, padding: 16, background: "#fefce8", border: "1px solid #fde68a", borderRadius: 8, fontSize: 12, color: "#854d0e" }}>
                    <strong>Note:</strong> Keep your login credentials safe. Contact support if you need assistance.
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ══════════ CHANGE PASSWORD ══════════ */}
          {subTab === "Change Password" && (
            <ChangePasswordPanel memberToken={m.token_number} couponNo={m.receiver_coupon_no} />
          )}

          {/* Fallback */}
          {tab !== "dashboard" && !subTab && (
            <div style={{ padding: 40, textAlign: "center", color: "#94a3b8" }}>
              <div style={{ fontSize: 32, marginBottom: 10 }}>👆</div>
              Tap the menu (☰) to navigate
            </div>
          )}
        </main>
      </div>

      {/* ── MOBILE BOTTOM NAV ── */}
      {isMobile && (
        <nav style={{
          position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 500,
          background: "#1e3a8a", display: "flex", borderTop: "2px solid #1d4ed8",
          boxShadow: "0 -2px 12px rgba(0,0,0,.3)",
        }}>
          {[
            { icon: "📊", label: "Home", action: () => goTo("dashboard") },
            { icon: "👥", label: "Team", action: () => { setOpenNav(p => ({ ...p, myteam: true })); setSidebarOpen(true); } },
            { icon: "💹", label: "Income", action: () => { setOpenNav(p => ({ ...p, incentive: true })); setSidebarOpen(true); } },
            { icon: "💰", label: "Wallet", action: () => goTo("wallet", "Wallet Report") },
            { icon: "☰", label: "Menu", action: () => setSidebarOpen(o => !o) },
          ].map(item => (
            <button key={item.label} onClick={item.action}
              style={{ flex: 1, background: "none", border: "none", color: "#bfdbfe",
                padding: "10px 4px 8px", cursor: "pointer", textAlign: "center",
                fontSize: 10, display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
              <span style={{ fontSize: 20 }}>{item.icon}</span>
              <span>{item.label}</span>
            </button>
          ))}
        </nav>
      )}
      {isMobile && <div style={{ height: 64 }} />}
    </div>
  );
}

/* ══════════════════════════════════════════════════════
   WITHDRAWAL DETAIL PANEL
   ★ Uses existingBank from my-stats (already loaded).
   ★ On mount: pre-fills from existingBank immediately —
     no extra API call needed, no blank screen on refresh.
   ★ On save: PUT /wallet/bank/:token then updates preview.
══════════════════════════════════════════════════════ */
function WithdrawalDetailPanel({ token, existingBank }) {
  const EMPTY = { bank_name: "", account_number: "", ifsc: "", upi_id: "" };

  // Pre-fill from already-loaded member data instantly
  const initForm = {
    bank_name:      existingBank?.bank_name      || "",
    account_number: existingBank?.account_number || "",
    ifsc:           existingBank?.ifsc           || "",
    upi_id:         existingBank?.upi_id         || "",
  };

  const [form, setForm]   = useState(initForm);
  const [saved, setSaved] = useState(
    // Show preview card immediately if data already exists
    (initForm.bank_name || initForm.account_number || initForm.ifsc || initForm.upi_id)
      ? initForm
      : null
  );
  const [saving, setSaving] = useState(false);

  // Also fetch fresh from server in background (in case my-stats was cached/old)
  useEffect(() => {
    api.get(`/wallet/bank/${token}`)
      .then(res => {
        const d = res.data;
        if (d && (d.bank_name || d.account_number || d.ifsc || d.upi_id)) {
          const fresh = {
            bank_name:      d.bank_name      || "",
            account_number: d.account_number || "",
            ifsc:           d.ifsc           || "",
            upi_id:         d.upi_id         || "",
          };
          setForm(fresh);
          setSaved(fresh);
        }
      })
      .catch(() => {/* use existingBank fallback already set above */});
  }, [token]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put(`/wallet/bank/${token}`, form);
      toast.success("Bank details saved!");
      setSaved({ ...form });
    } catch {
      toast.error("Save failed");
    }
    setSaving(false);
  };

  const fields = [
    ["Bank Name",      "bank_name",      "🏦", "e.g. State Bank of India"],
    ["Account Number", "account_number", "🔢", "e.g. 1234567890"],
    ["IFSC Code",      "ifsc",           "🏷️", "e.g. SBIN0001234"],
    ["UPI ID",         "upi_id",         "📱", "e.g. name@upi"],
  ];

  const hasData = saved && (saved.bank_name || saved.account_number || saved.ifsc || saved.upi_id);

  return (
    <div>
      <PageHead title="🏦 Bank / UPI Details" />
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", alignItems: "flex-start" }}>

        {/* ── LEFT: Form ── */}
        <div style={{ ...S.card, flex: "1 1 280px", maxWidth: 460 }}>
          <div style={S.cardHead}>Add / Update Payment Details</div>
          <div style={{ padding: 20 }}>
            <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: 12, marginBottom: 16, fontSize: 12, color: "#1e40af" }}>
              💡 These details are used when you request a withdrawal. Keep them accurate.
            </div>
            {fields.map(([label, key, icon, placeholder]) => (
              <div key={key} style={{ marginBottom: 14 }}>
                <label style={S.label}>{icon} {label}</label>
                <input
                  style={S.input}
                  placeholder={placeholder}
                  value={form[key]}
                  onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
                />
              </div>
            ))}
            <button
              style={{ ...S.btn, background: saving ? "#94a3b8" : "#1e3a8a", width: "100%", padding: 12, fontSize: 14, justifyContent: "center" }}
              onClick={handleSave}
              disabled={saving}
            >
              {saving ? "Saving..." : "💾 Save Payment Details"}
            </button>
          </div>
        </div>

        {/* ── RIGHT: Preview card ── */}
        <div style={{ flex: "1 1 260px", maxWidth: 400 }}>
          {hasData ? (
            <>
              {/* Bank debit-card style */}
              <div style={{
                background: "linear-gradient(135deg, #1e3a8a 0%, #1d4ed8 55%, #3b82f6 100%)",
                borderRadius: 18, padding: "24px 24px 20px", color: "#fff",
                boxShadow: "0 10px 36px rgba(30,58,138,.38)",
                position: "relative", overflow: "hidden", marginBottom: 14,
              }}>
                <div style={{ position: "absolute", top: -28, right: -28, width: 110, height: 110, borderRadius: "50%", background: "rgba(255,255,255,.08)" }} />
                <div style={{ position: "absolute", bottom: -36, left: -16, width: 140, height: 140, borderRadius: "50%", background: "rgba(255,255,255,.05)" }} />
                <div style={{ position: "absolute", top: 20, right: 20, width: 50, height: 50, borderRadius: "50%", background: "rgba(255,255,255,.12)" }} />

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 22 }}>
                  <div>
                    <div style={{ fontSize: 9, opacity: .65, letterSpacing: 2.5, marginBottom: 4 }}>BANK NAME</div>
                    <div style={{ fontSize: 16, fontWeight: 800, letterSpacing: .4 }}>{saved.bank_name || "—"}</div>
                  </div>
                  <div style={{ fontSize: 32, lineHeight: 1 }}>🏦</div>
                </div>

                <div style={{ marginBottom: 18 }}>
                  <div style={{ fontSize: 9, opacity: .65, letterSpacing: 2.5, marginBottom: 4 }}>ACCOUNT NUMBER</div>
                  <div style={{ fontSize: 18, fontWeight: 700, letterSpacing: 4, fontFamily: "monospace" }}>
                    {saved.account_number
                      ? saved.account_number.replace(/(.{4})/g, "$1 ").trim()
                      : "—"}
                  </div>
                </div>

                <div style={{ display: "flex", gap: 28 }}>
                  <div>
                    <div style={{ fontSize: 9, opacity: .65, letterSpacing: 2.5, marginBottom: 3 }}>IFSC CODE</div>
                    <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: .5 }}>{saved.ifsc || "—"}</div>
                  </div>
                  <div>
                    <div style={{ fontSize: 9, opacity: .65, letterSpacing: 2.5, marginBottom: 3 }}>ACCOUNT TYPE</div>
                    <div style={{ fontSize: 13, fontWeight: 700 }}>SAVINGS</div>
                  </div>
                </div>
              </div>

              {saved.upi_id && (
                <div style={{
                  background: "linear-gradient(135deg, #064e3b 0%, #065f46 100%)",
                  borderRadius: 14, padding: "16px 20px", color: "#fff",
                  boxShadow: "0 6px 20px rgba(6,79,59,.32)",
                  display: "flex", alignItems: "center", gap: 14, marginBottom: 14,
                }}>
                  <div style={{ fontSize: 34, lineHeight: 1 }}>📱</div>
                  <div>
                    <div style={{ fontSize: 9, opacity: .7, letterSpacing: 2.5, marginBottom: 4 }}>UPI ID</div>
                    <div style={{ fontSize: 15, fontWeight: 800, letterSpacing: .3 }}>{saved.upi_id}</div>
                    <div style={{ fontSize: 11, opacity: .7, marginTop: 3 }}>Instant transfer ready</div>
                  </div>
                </div>
              )}

              <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 10 }}>
                <span style={{ fontSize: 20 }}>✅</span>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "#15803d" }}>Payment Details Saved</div>
                  <div style={{ fontSize: 11, color: "#16a34a" }}>Withdrawals will be sent to these details</div>
                </div>
              </div>
            </>
          ) : (
            <div style={{
              border: "2px dashed #cbd5e1", borderRadius: 16, padding: "40px 28px",
              textAlign: "center", color: "#94a3b8", background: "#f8fafc",
              display: "flex", flexDirection: "column", alignItems: "center", gap: 10,
            }}>
              <div style={{ fontSize: 48 }}>🏦</div>
              <div style={{ fontWeight: 700, fontSize: 14, color: "#64748b" }}>No Details Added Yet</div>
              <div style={{ fontSize: 12, lineHeight: 1.6 }}>
                Fill in the form and tap<br />
                <strong style={{ color: "#1e3a8a" }}>Save Payment Details</strong><br />
                to see your bank card preview here
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
}


/* ══════════════════════════════════════════════════════
   CHANGE PASSWORD — isolated component with own state
══════════════════════════════════════════════════════ */
function ChangePasswordPanel({ memberToken, couponNo }) {
  const [current, setCurrent] = useState("");
  const [newPwd, setNewPwd]   = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!newPwd)           { toast.error("New password is required"); return; }
    if (newPwd.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (newPwd !== confirm) { toast.error("Passwords do not match"); return; }
    setLoading(true);
    try {
      await api.post("/mlm/member-change-password", {
        token_number: memberToken,
        old_password: current || undefined,
        new_password: newPwd,
      });
      toast.success("✅ Password changed successfully!");
      setCurrent(""); setNewPwd(""); setConfirm("");
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div>
      <PageHead title="🔐 Change Password" />
      <div style={{ ...S.card, maxWidth: "min(500px, 100%)" }}>
        <div style={S.cardHead}>Update Your Password</div>
        <div style={{ padding: 24 }}>
          <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: 12, marginBottom: 16, fontSize: 12, color: "#1e40af" }}>
            💡 <strong>First time?</strong> Leave "Current Password" blank to set your password for the first time.
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={S.label}>User ID (Coupon No)</label>
            <input style={{ ...S.input, background: "#f8fafc", color: "#64748b" }} value={couponNo} readOnly />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={S.label}>Current Password <span style={{ color: "#94a3b8", fontSize: 11 }}>(leave blank if setting for first time)</span></label>
            <input type="password" style={S.input} placeholder="Enter current password"
              value={current} onChange={e => setCurrent(e.target.value)} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={S.label}>New Password *</label>
            <input type="password" style={S.input} placeholder="Minimum 6 characters"
              value={newPwd} onChange={e => setNewPwd(e.target.value)} />
          </div>
          <div style={{ marginBottom: 8 }}>
            <label style={S.label}>Confirm New Password *</label>
            <input type="password" style={S.input} placeholder="Re-enter new password"
              value={confirm} onChange={e => setConfirm(e.target.value)} />
          </div>
          {confirm.length > 0 && (
            <div style={{ marginBottom: 16, fontSize: 12, fontWeight: 700, color: newPwd === confirm ? "#16a34a" : "#dc2626" }}>
              {newPwd === confirm ? "✅ Passwords match" : "❌ Passwords do not match"}
            </div>
          )}
          <button
            style={{ ...S.btn, background: loading ? "#94a3b8" : "#1e3a8a", width: "100%", padding: 12, fontSize: 14 }}
            onClick={handleSubmit} disabled={loading}>
            {loading ? "Updating..." : "🔐 Update Password"}
          </button>
          <p style={{ fontSize: 11, color: "#94a3b8", marginTop: 12, textAlign: "center" }}>
            Need help? <a href="https://wa.me/918275547499" target="_blank" rel="noreferrer"
              style={{ color: "#25D366", fontWeight: 600 }}>Contact WhatsApp Support</a>
          </p>
        </div>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════════════
   DATE WISE BUSINESS
══════════════════════════════════════════════════════ */
function DateWiseBusiness({ directMembers, allTeam }) {
  const [from, setFrom] = useState(() => new Date(Date.now() - 7 * 86400000).toISOString().slice(0, 10));
  const [to, setTo]     = useState(() => new Date().toISOString().slice(0, 10));

  const allMembers = [
    ...directMembers.map(d => ({ ...d, lvl: 1 })),
    ...allTeam.filter(t => Number(t.lvl) > 1),
  ];

  const filtered = allMembers.filter(mem => {
    const d = mem.created_at?.slice(0, 10);
    return d && d >= from && d <= to;
  });

  const grouped = {};
  filtered.forEach(mem => {
    const d = mem.created_at.slice(0, 10);
    if (!grouped[d]) grouped[d] = { date: d, count: 0, levels: {} };
    grouped[d].count++;
    const lvl = Number(mem.lvl);
    grouped[d].levels[lvl] = (grouped[d].levels[lvl] || 0) + 1;
  });
  const rows = Object.values(grouped).sort((a, b) => b.date.localeCompare(a.date));
  const totalJoins = rows.reduce((s, r) => s + r.count, 0);

  return (
    <div>
      <PageHead title="📅 Date Wise Business Report" />
      <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap", alignItems: "flex-end" }}>
        <div>
          <label style={S.label}>From Date</label>
          <input type="date" style={{ ...S.input, width: "auto" }} value={from} onChange={e => setFrom(e.target.value)} />
        </div>
        <div>
          <label style={S.label}>To Date</label>
          <input type="date" style={{ ...S.input, width: "auto" }} value={to} onChange={e => setTo(e.target.value)} />
        </div>
      </div>
      <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
        {[["Total Joins", totalJoins, "#1e3a8a"], ["Active Days", rows.length, "#065f46"], ["Avg/Day", rows.length ? Math.round(totalJoins / rows.length) : 0, "#7f1d1d"]].map(([label, val, bg]) => (
          <div key={label} style={{ ...S.kpiCard, background: bg, flex: 1, minWidth: 130 }}>
            <div style={{ fontSize: 24, fontWeight: 800 }}>{val}</div>
            <div style={{ fontSize: 11, opacity: .8 }}>{label}</div>
          </div>
        ))}
      </div>
      <div style={S.tableWrap}>
        <table style={S.table}>
          <THead cols={["Date", "Total Joins", "L1", "L2", "L3", "L4", "L5", "L6"]} />
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.date} style={i % 2 === 0 ? S.trEven : {}}>
                <td style={{ ...S.td, fontWeight: 700 }}>{fmt(r.date)}</td>
                <td style={{ ...S.td, fontWeight: 800, color: "#1d4ed8", fontSize: 15 }}>{r.count}</td>
                {[1, 2, 3, 4, 5, 6].map(l => (
                  <td key={l} style={{ ...S.td, color: r.levels[l] ? PIE_COLORS[l - 1] : "#cbd5e1", fontWeight: r.levels[l] ? 700 : 400 }}>
                    {r.levels[l] || 0}
                  </td>
                ))}
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#94a3b8", padding: 32 }}>
                No joins found in selected date range
              </td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ── Sub-components ── */
function PageHead({ title, children }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16, paddingBottom: 12, borderBottom: "2px solid #e2e8f0" }}>
      <div style={{ width: 4, height: 20, background: "#ea580c", borderRadius: 99 }} />
      <span style={{ fontWeight: 700, fontSize: 16, color: "#1e293b" }}>{title}</span>
      {children}
    </div>
  );
}
function SectionTitle({ children }) {
  return <div style={{ fontWeight: 700, fontSize: 13, color: "#1e3a8a", margin: "18px 0 10px", borderLeft: "4px solid #ea580c", paddingLeft: 10 }}>{children}</div>;
}
function THead({ cols }) {
  return (
    <thead>
      <tr style={{ background: "#1e3a8a", color: "#fff" }}>
        {cols.map(c => <th key={c} style={{ padding: "10px 12px", textAlign: "left", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}>{c}</th>)}
      </tr>
    </thead>
  );
}

/* ── Direct Tree: box layout ── */
function TreeBoxNode({ name, coupon, isRoot, isApproved, subCount, children = [] }) {
  return (
    <div style={{ textAlign: "center", margin: "0 6px" }}>
      <div style={{
        padding: "8px 14px",
        background: isRoot ? "linear-gradient(135deg,#ea580c,#f97316)" : "#1e3a8a",
        color: "#fff", borderRadius: 8, fontSize: 12, fontWeight: 700,
        display: "inline-block", boxShadow: "0 2px 8px rgba(0,0,0,.2)", minWidth: 100,
        border: isRoot ? "2px solid #fff" : "none",
      }}>
        <div>{name}</div>
        {coupon && <div style={{ fontSize: 10, opacity: .8, marginTop: 2 }}>{coupon}</div>}
        {subCount !== undefined && (
          <div style={{ fontSize: 10, marginTop: 3, background: "rgba(255,255,255,.2)", borderRadius: 4, padding: "1px 4px" }}>
            {subCount} direct
          </div>
        )}
        {isApproved !== undefined && (
          <div style={{ fontSize: 10, marginTop: 2, color: isApproved ? "#4ade80" : "#fbbf24" }}>
            {isApproved ? "Active ✅" : "Pending ⏳"}
          </div>
        )}
      </div>
      {children.length > 0 && (
        <>
          <div style={{ width: 2, height: 20, background: "#94a3b8", margin: "0 auto" }} />
          <div style={{ display: "flex", justifyContent: "center", position: "relative" }}>
            {children.length > 1 && (
              <div style={{ position: "absolute", top: 0, left: "10%", right: "10%", height: 2, background: "#94a3b8" }} />
            )}
            {children.map((child, i) => (
              <div key={i}>
                <div style={{ width: 2, height: 16, background: "#94a3b8", margin: "0 auto" }} />
                <TreeBoxNode {...child} />
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

/* ── Expandable tree node for Indirect Tree ── */
function ExpandableTreeNode({ node, depth = 0, isRoot = false }) {
  const [expanded, setExpanded] = useState(depth < 2);
  const DEPTH_COLORS = ["#1e3a8a", "#1d4ed8", "#3b82f6", "#60a5fa", "#93c5fd", "#bfdbfe"];
  const textColors =  ["#fff",     "#fff",     "#fff",     "#fff",    "#1e3a8a", "#1e3a8a"];
  if (!node) return null;
  const hasChildren = node.children && node.children.length > 0;
  return (
    <div style={{ marginLeft: Math.min(depth * 16, 80), marginBottom: 3 }}>
      <div onClick={() => hasChildren && setExpanded(e => !e)}
        style={{
          display: "flex", alignItems: "center", gap: 8, padding: "7px 12px",
          background: DEPTH_COLORS[Math.min(depth, 5)],
          color: textColors[Math.min(depth, 5)],
          borderRadius: 7, cursor: hasChildren ? "pointer" : "default",
          border: isRoot ? "2px solid #f97316" : "1px solid rgba(0,0,0,.08)",
          userSelect: "none",
        }}>
        <span style={{ fontSize: 11, minWidth: 14, opacity: .8 }}>
          {hasChildren ? (expanded ? "▼" : "▶") : "●"}
        </span>
        <span style={{ fontWeight: 700, fontSize: 12 }}>{node.receiver_coupon_no || node.token_number}</span>
        <span style={{ fontSize: 12 }}>{node.receiver_name}</span>
        {node.receiver_mobile && window.innerWidth >= 768 && (
          <span style={{ fontSize: 11, opacity: .75, marginLeft: 4 }}>{node.receiver_mobile}</span>
        )}
        {isRoot && <span style={{ fontSize: 10, background: "#f97316", borderRadius: 99, padding: "1px 7px", marginLeft: 4 }}>YOU</span>}
        {hasChildren && (
          <span style={{ marginLeft: "auto", background: "rgba(255,255,255,.25)", borderRadius: 99, padding: "1px 8px", fontSize: 11 }}>
            {node.children.length} ▸
          </span>
        )}
        <span style={{ background: node.is_approved ? "#16a34a" : "#f59e0b", borderRadius: 99, padding: "1px 6px", fontSize: 10, color: "#fff", marginLeft: hasChildren ? 0 : "auto" }}>
          {node.is_approved ? "✓" : "⏳"}
        </span>
      </div>
      {expanded && hasChildren && (
        <div style={{ borderLeft: "2px solid #bfdbfe", marginLeft: 16, paddingLeft: 6, marginTop: 3 }}>
          {node.children.map(child => (
            <ExpandableTreeNode key={child.token_number} node={child} depth={depth + 1} />
          ))}
        </div>
      )}
    </div>
  );
}

/* ── Styles ── */
const S = {
  shell: { display: "flex", flexDirection: "column", minHeight: "100vh", fontFamily: "'Segoe UI', system-ui, sans-serif", fontSize: 13, background: "#f1f5f9" },
  topbar: { background: "linear-gradient(90deg,#1e3a8a 0%,#1e40af 100%)", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", position: "sticky", top: 0, zIndex: 400, boxShadow: "0 2px 10px rgba(0,0,0,.3)" },
  logoBadge: { width: 36, height: 36, borderRadius: 9, background: "linear-gradient(135deg,#f97316,#ea580c)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 16, color: "#fff", flexShrink: 0 },
  rankBadge: { background: "rgba(255,255,255,.15)", border: "1px solid rgba(255,255,255,.3)", borderRadius: 99, padding: "3px 12px", fontSize: 11, fontWeight: 700, color: "#fef3c7" },
  logoutBtn: { background: "rgba(239,68,68,.85)", border: "none", color: "#fff", padding: "6px 12px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 12, flexShrink: 0 },
  sidebar: { width: 200, background: "#1e3a8a", minHeight: "calc(100vh - 56px)", flexShrink: 0 },
  navItem: { color: "#bfdbfe", padding: "13px 16px", cursor: "pointer", display: "flex", alignItems: "center", fontSize: 13, borderBottom: "1px solid rgba(255,255,255,.06)", fontWeight: 500 },
  navActive: { background: "#ea580c", color: "#fff" },
  navSub: { color: "#93c5fd", padding: "11px 16px 11px 28px", cursor: "pointer", fontSize: 12, background: "rgba(0,0,0,.25)", borderBottom: "1px solid rgba(255,255,255,.04)" },
  navSubActive: { background: "#ea580c", color: "#fff", fontWeight: 700 },
  content: { flex: 1, padding: 16, overflowX: "hidden", minWidth: 0 },
  kpiGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: 10, marginBottom: 16 },
  kpiCard: { color: "#fff", borderRadius: 10, padding: "14px 16px", display: "flex", flexDirection: "column", gap: 4, boxShadow: "0 2px 8px rgba(0,0,0,.15)" },
  card: { background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden" },
  cardHead: { background: "#1e3a8a", color: "#fff", padding: "10px 16px", fontWeight: 700, fontSize: 13 },
  tableWrap: { background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0", overflowX: "auto", marginBottom: 16, WebkitOverflowScrolling: "touch" },
  table: { width: "100%", borderCollapse: "collapse", minWidth: 480 },
  td: { padding: "9px 10px", fontSize: 12, borderBottom: "1px solid #f1f5f9", verticalAlign: "middle", whiteSpace: "nowrap" },
  trEven: { background: "#f8fafc" },
  pill: { background: "#eff6ff", color: "#1d4ed8", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 600 },
  greenBadge: { background: "#dcfce7", color: "#15803d", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
  yellowBadge: { background: "#fef9c3", color: "#854d0e", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
  redBadge: { background: "#fee2e2", color: "#991b1b", padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 700 },
  label: { display: "block", fontSize: 12, color: "#475569", marginBottom: 4, fontWeight: 600 },
  input: { border: "1px solid #e2e8f0", padding: "9px 12px", width: "100%", fontSize: 13, borderRadius: 6, outline: "none", boxSizing: "border-box" },
  btn: { color: "#fff", border: "none", padding: "7px 14px", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13, display: "inline-flex", alignItems: "center", gap: 4 },
  btnPrimary: { background: "#1e3a8a", color: "#fff", border: "none", padding: "9px 20px", borderRadius: 6, cursor: "pointer", fontWeight: 700, fontSize: 13 },
  loginWrap: { minHeight: "100vh", background: "linear-gradient(135deg,#1e3a8a 0%,#1e40af 100%)", display: "flex", alignItems: "center", justifyContent: "center" },
  loginBox: { background: "#fff", borderRadius: 14, padding: 40, width: 340, boxShadow: "0 24px 60px rgba(0,0,0,.25)" },
  loginLogo: { width: 60, height: 60, borderRadius: 14, background: "linear-gradient(135deg,#f97316,#ea580c)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 24, color: "#fff", margin: "0 auto", boxShadow: "0 4px 16px rgba(234,88,12,.4)" },
};